/* eslint-disable react/no-unknown-property */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-unreachable */
/* eslint-disable react/jsx-key */
/* eslint-disable no-undef */
import axios from 'axios';
import { debounce } from 'debounce';
import moment from 'moment';
import { useEffect, useState } from 'react';
import ReactSelect from 'react-select';
import { Box, Button, Flex, Heading, Image, Input, Label, Link, Paragraph, Select, Switch } from 'theme-ui';
import { defaultErrorState } from '../../pages/definitions';
import { deleteClient, getSingleClient, updateClientData, verifyHMRCToken } from '../clients/api';
import { loadCountriesAndReturn } from '../select-country';
import Spinner from '../spinner';
import { TableRowClients } from '../table';
import { Title } from '../templates/add-new';
import { loadClients } from './api';

import AsyncSelect from 'react-select/async';
import theme from '../../theme';
import { PgPaginationV2 } from '../documents/paging';
import AddAComment from '../tasks/add-a-comment';
import { loadClientComments } from '../tasks/api';
import Comment from '../tasks/comment';
import ConfirmDialog from '../tasks/confirm-dialog';
import ClientRelations from './client-relations';
import DocSign from './doc-sign';
import FileExplorer from './file-explorer';
import GenerateInvoice from './generate-invoice';
import HmrcSpec from './hmrc-spec';
import KeyContacts from './key-contacts';
import Invoices from './invoices';
import EditClientData, { allDataCollected, clientStatusOptions } from './edit-client-data';
import Divider from '../divider';
import Overlay from '../overlay/overlay';
import QuickbooksLinkOverlay from './quickbooks-link-overlay';
import { toast } from 'react-toastify';
import ClientSetupProgressIndicator from './client-setup-progress';
import XeroLinkOverlay from './xero-link-overlay';
import Emails from './emails';
import Proposals from './proposals';
import Expenses from './expenses';
import Post from './post';

const fieldsToIgnoreInRecord = ['new_client_services_offered', 'vat_registered', 'key_contacts'];

function setValueByPath(obj, path, value) {
    // Split the path into an array of keys
    const keys = path.split('.');
    // Iterate over the keys array, except for the last element
    const lastKey = keys.pop(); // Remove and save the last key for later
    let current = obj;
    keys.forEach((key) => {
        // If the key doesn't exist or it's not an object, create a new object for it
        if (!current[key] || typeof current[key] !== 'object') {
            current[key] = {};
        }
        // Move to the next level in the object
        current = current[key];
    });
    // Set the value at the final key
    current[lastKey] = value;
}

export const QuickbooksImg = ({ width = 90 }) => (
    <img
        style={{ width }}
        src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2344.83 600'%3E%3Cpath fill='%232ca01c' d='M267.54 535.08c147.76 0 267.54-119.78 267.54-267.54S415.3 0 267.54 0 0 119.78 0 267.54s119.78 267.54 267.54 267.54Z'/%3E%3Cpath fill='%23fff' d='M178.36 163.5c-57.49 0-104.04 46.61-104.04 104.04s46.55 104.04 104.04 104.04h14.86v-38.64h-14.86c-36.09 0-65.4-29.31-65.4-65.4s29.31-65.4 65.4-65.4h35.73v202.14c0 21.34 17.3 38.64 38.64 38.64V163.5h-74.38ZM356.78 371.58c57.49 0 104.04-46.61 104.04-104.04S414.27 163.5 356.78 163.5h-14.86v38.65h14.86c36.09 0 65.4 29.31 65.4 65.4s-29.31 65.4-65.4 65.4h-35.73V130.8c0-21.34-17.3-38.64-38.64-38.64v279.42h74.38Z'/%3E%3Cpath d='M789.12 600h-41.38V495.18h-.71c-10.7 16.53-31.75 26.87-54.82 26.87-50.36 0-81.39-40.01-81.39-88.29s33.11-86.92 80.32-86.92c30.32 0 48.99 14.8 57.25 27.94h1.01v-23.13h39.66v248.34h.06Zm-88.59-112.43c30.32 0 48.63-27.23 48.63-53.09s-18.25-53.8-48.63-53.8c-32.04 0-47.56 27.23-47.56 53.09-.06 25.86 15.46 53.81 47.56 53.81ZM974.97 517.24h-39.3v-26.58h-.71c-7.25 16.53-26.87 31.39-51.37 31.39-43.1 0-61.06-33.12-61.06-66.88V351.72h41.38v91.74c0 19.68 4.46 44.11 31.03 44.11s38.64-22.77 38.64-44.83v-91.02h41.38v165.52ZM1016.47 348.1h41.38v165.52h-41.38V348.1ZM1212.67 397.56c-6.54-9.33-20.69-16.23-34.13-16.23-30.32 0-45.54 27.23-45.54 53.09s15.52 53.09 46.91 53.09c12.78 0 26.87-5.17 34.84-14.8l25.86 26.22c-13.8 14.8-36.57 23.13-61.06 23.13-48.99 0-89.66-32.4-89.66-87.57s40.02-87.58 88.65-87.58c24.14 0 49.29 9.63 62.42 25.86l-28.29 24.79ZM1261.3 256.54h41.38v164.8h1.01l62.78-69.68h53.09l-71.7 74.85 76.22 90.67h-54.81l-65.52-84.84h-1.01v84.84h-41.38V256.54h-.06ZM1484.37 256.54v116.23h1.01c8.62-10.7 25.15-25.86 55.53-25.86 47.26 0 80.32 37.93 80.32 86.92s-31.04 88.29-81.39 88.29c-23.13 0-45.55-10.7-56.9-29.67h-.71v24.85h-39.3V256.54h41.44Zm47.26 124.14c-30.32 0-48.63 27.94-48.63 53.8s18.25 53.09 48.63 53.09c32.05 0 47.56-27.94 47.56-53.81s-15.51-53.09-47.56-53.09ZM1729.19 346.91c50 0 90.02 34.84 90.02 86.92s-40.02 88.29-90.02 88.29-90.01-36.21-90.01-88.29 40.01-86.92 90.01-86.92Zm0 140.67c32.76 0 47.92-27.94 47.92-53.81s-15.16-53.09-47.92-53.09-47.92 27.23-47.92 53.09 15.16 53.81 47.92 53.81ZM1927.17 346.91c50 0 90.01 34.84 90.01 86.92s-40.01 88.29-90.01 88.29-90.01-36.21-90.01-88.29 40.01-86.92 90.01-86.92Zm0 140.67c32.76 0 47.92-27.94 47.92-53.81s-15.16-53.09-47.92-53.09-47.92 27.23-47.92 53.09c-.06 25.86 15.16 53.81 47.92 53.81ZM2042.33 256.54h41.38v164.8h1.01l62.79-69.68h53.09l-71.7 74.85 76.22 90.67h-54.82l-65.52-84.84h-1.01v84.84h-41.38V256.54h-.06ZM2318.02 395.84c-7.26-9.63-21.05-17.95-36.21-17.95-13.08 0-26.58 4.82-26.58 17.95s12.79 16.23 35.85 21.7c24.5 5.89 53.45 16.89 53.45 49.29 0 40.37-32.76 55.17-68.96 55.17-25.51 0-52.08-9.63-67.96-27.23l27.23-25.51c8.98 11.71 24.5 20.69 42.39 20.69 12.07 0 26.58-4.82 26.58-19.68 0-13.79-12.79-17.95-37.93-23.78-24.5-5.89-48.99-15.87-48.99-46.91 0-36.92 33.11-52.73 65.87-52.73 23.78 0 48.63 8.26 62.07 25.15l-26.81 23.84ZM1064.21 125.74c0 41.97 33.59 72.65 76.28 72.65s76.34-30.62 76.34-72.65V29.37h-41.38v91.44c0 22.65-15.16 37.81-35.08 37.81s-35.08-15.16-35.08-37.81V29.37h-41.32l.24 96.37ZM1327.35 68.07h49.35v126.99h41.32V68.07h49.28v-38.7h-139.95v38.7ZM1300.6 29.37h-41.32v165.7h41.32V29.37ZM897.27 68.07h49.35v126.99h41.32V68.07h49.29v-38.7H897.28v38.7ZM680.44 29.37h-41.32v165.7h41.32V29.37ZM875.51 98.69c0-41.97-33.65-72.65-76.34-72.65s-76.34 30.62-76.34 72.65v96.37h41.32v-91.43c0-22.65 15.16-37.81 35.08-37.81s35.08 15.16 35.08 37.81v91.44h41.32l-.12-96.37Z'/%3E%3C/svg%3E"
    />
);

const saveCompaniesHouseData = async (state, updateState) => {
    try {
        updateState({ ...state, loading: true, error: null });

        await axios({
            url: `${process.env.REACT_APP_AQRU_AI_API}/clients/${state.clientInView.id}/ch`,
            method: 'PUT',
            data: {
                ...state.companiesHouseData,
            },
        });

        updateState({ ...state, loading: false, error: null });
    } catch (e) {
        updateState({
            ...state,
            loading: false,
            error: 'There has been an error saving your data, please try again or contact support',
        });
    }
};

const createClient = async (state, updateState, errorState, updateErrorState) => {
    let errors = 0;
    let errorData = {
        companyId: false,
        individualName: false,
        vat_number: false,
        relations: false,
    };

    if (!state.default_partners?.length && !state.default_preparers?.length && !state.default_reviewers?.length) {
        errors++;
        errorData.relations = true;
    }

    if (state.clientType?.value === 'company' && !state.overseas && !state.companyId) {
        errors++;
        errorData.companyId = true;
    }

    if (state.clientType?.value === 'individual' && !state.individualName) {
        errors++;
        errorData.individualName = true;
    }

    if (!state.internal_reference_code && !state.autoGenerateClientCode) {
        errors++;
        errorData.internal_reference_code = true;
    }

    if (state.vat_registered && !state.vat_number) {
        errors++;
        errorData.vat_number = true;
    }

    if (errors > 0) {
        toast('Please enter the required fields', { type: 'error' });
        updateErrorState({ ...errorData });
    } else {
        updateState({ ...state, loading: true });
        updateErrorState({ ...errorState, ...errorData });
        try {
            let id;
            try {
                const { data } = await axios({
                    url: `${process.env.REACT_APP_AQRU_AI_API}/clients`,
                    method: 'POST',
                    data: {
                        company_number:
                            state.clientType?.value === 'individual' || state.overseas ? undefined : state.companyId,
                        type: state.clientType?.value,
                        overseas: !!state.overseas,
                        auto_generate_ref: !!state.autoGenerateClientCode,
                        name:
                            state.clientType?.value === 'individual'
                                ? state.individualName
                                : state.overseas
                                ? state.individualName
                                : undefined,
                        internal_reference_code: state.internal_reference_code,
                        relations: [
                            ...(state.default_partners || [])?.map((x) => ({ type: 'partner', id: x.value })),
                            ...(state.default_reviewers || [])?.map((x) => ({ type: 'reviewer', id: x.value })),
                            ...(state.default_preparers || [])?.map((x) => ({ type: 'assigned_to', id: x.value })),
                        ],
                        status: state.clientStatus?.value || 'customer',
                        client_data: {
                            vat_registered: state.vat_registered,
                            vat_number: state.vat_registered ? state.vat_number : '',
                            new_client_services_offered: Object.entries(state.newClientServicesOffered)
                                .filter((x) => x[1])
                                .map((x) => x[0]),
                        },
                    },
                });
                window.location.assign(`/clients?id=${data.id}`);
            } catch (e) {
                if (e.response.status === 400) {
                    return updateState({ ...state, loading: false, error: e.response.data.message });
                }
                return updateState({
                    ...state,
                    loading: false,
                    error: 'Something has gone wrong creating this client',
                });
            }
        } catch (e) {
            updateState({
                ...state,
                loading: false,
                error: 'failed to add new company, is the ID correct?',
            });
        }
    }
};

export const loadCompaniesAsync = (state, updateState) => async (inputValue) => {
    try {
        const { data } = await axios.get(`${process.env.REACT_APP_AQRU_AI_API}/clients/ch-companies`, {
            params: { name: inputValue },
        });

        return [
            ...(data.companies?.map((x) => ({
                value: x.company_number,
                label: x.company_name + ' ' + x.address_line_1,
            })) || []),
        ];
    } catch (e) {
        console.log(e);
        return [];
    }
};

export const Create = ({ state, updateState, errorState, updateErrorState, isMobile, navigate }) => {
    return (
        <Flex
            sx={{
                width: '1400px',
                flexDirection: 'row',
                border: '0px red solid',
                mt: '0px',
            }}
        >
            <Flex
                sx={{
                    flexDirection: 'column',
                    pr: '40px',
                    borderRight: '0px solid #a3a69b',
                }}
            >
                <Label id="client-type-label">Client type</Label>

                <ReactSelect
                    aria-labelledby="client-type-label"
                    styles={{
                        control: (provided) => ({
                            ...provided,
                            boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.2)',
                            width: '400px',
                            minHeight: '40px',
                            marginTop: '10px',
                            borderRadius: 10,
                            marginBottom: '10px',
                            border: '1px solid #a3a69b',
                            fontSize: '14px',
                        }),
                    }}
                    onChange={(value) => updateState({ ...state, clientType: value })}
                    placeholder={'Select the client type'}
                    value={state?.clientType}
                    options={[
                        {
                            value: 'company',
                            label: 'Company',
                        },
                        {
                            value: 'individual',
                            label: 'Individual',
                        },
                    ]}
                />

                <Label sx={{ mt: 10 }} id="client-type-label">
                    Status
                </Label>

                <ReactSelect
                    aria-labelledby="client-type-label"
                    styles={{
                        control: (provided) => ({
                            ...provided,
                            boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.2)',
                            width: '400px',
                            minHeight: '40px',
                            marginTop: '10px',
                            borderRadius: 10,
                            marginBottom: '10px',
                            border: '1px solid #a3a69b',
                            fontSize: '14px',
                        }),
                    }}
                    onChange={(value) => updateState({ ...state, clientStatus: value })}
                    placeholder={'Select the client status'}
                    value={
                        state?.clientStatus || {
                            value: 'customer',
                            label: 'Customer',
                        }
                    }
                    options={[
                        {
                            value: 'customer',
                            label: 'Customer',
                        },
                        {
                            value: 'prospect',
                            label: 'Prospect',
                        },
                    ]}
                />

                <Flex sx={{ mt: 20, flexDirection: 'column' }}>
                    <Label sx={{ mt: 0 }} id="preparers-label">
                        Default Preparer
                    </Label>

                    <ReactSelect
                        aria-labelledby="preparers-label"
                        styles={{
                            control: (provided) => ({
                                ...provided,
                                boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.2)',
                                width: '400px',
                                minHeight: '40px',
                                marginTop: '10px',
                                borderRadius: 10,
                                marginBottom: '10px',
                                fontSize: '14px',
                                border: errorState?.relations ? '1px solid red' : '1px solid #a3a69b',
                            }),
                        }}
                        isMulti
                        onChange={async (c) => {
                            updateState({
                                ...state,
                                default_preparers: c,
                            });
                        }}
                        placeholder="Select..."
                        value={state.default_preparers}
                        options={[
                            ...(state?.users?.map((x) => ({
                                value: x.raw_id,
                                label: x.first_name ? `${x.first_name} ${x.last_name}` : x.email_address,
                            })) || []),
                        ]}
                    />
                </Flex>

                <Flex sx={{ mt: 20, flexDirection: 'column' }}>
                    <Label sx={{ mt: 0 }} id="reviewer-label">
                        Default Reviewer
                    </Label>

                    <ReactSelect
                        aria-labelledby="reviewer-label"
                        styles={{
                            control: (provided) => ({
                                ...provided,
                                boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.2)',
                                width: '400px',
                                minHeight: '40px',
                                marginTop: '10px',
                                borderRadius: 10,
                                marginBottom: '10px',
                                fontSize: '14px',
                                border: errorState?.relations ? '1px solid red' : '1px solid #a3a69b',
                            }),
                        }}
                        isMulti
                        onChange={async (c) => {
                            updateState({
                                ...state,
                                default_reviewers: c,
                            });
                        }}
                        placeholder="Select..."
                        value={state.default_reviewers}
                        options={[
                            ...(state?.users?.map((x) => ({
                                value: x.raw_id,
                                label: x.first_name ? `${x.first_name} ${x.last_name}` : x.email_address,
                            })) || []),
                        ]}
                    />
                </Flex>

                <Flex sx={{ mt: 20, flexDirection: 'column' }}>
                    <Label sx={{ mt: 0 }} id="partner-label">
                        Default Partner
                    </Label>

                    <ReactSelect
                        aria-labelledby="partner-label"
                        styles={{
                            control: (provided) => ({
                                ...provided,
                                boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.2)',
                                width: '400px',
                                minHeight: '40px',
                                marginTop: '10px',
                                borderRadius: 10,
                                marginBottom: '10px',
                                fontSize: '14px',
                                border: errorState?.relations ? '1px solid red' : '1px solid #a3a69b',
                            }),
                        }}
                        isMulti
                        onChange={async (c) => {
                            updateState({
                                ...state,
                                default_partners: c,
                            });
                        }}
                        placeholder="Select..."
                        value={state.default_partners}
                        options={[
                            ...(state?.users?.map((x) => ({
                                value: x.raw_id,
                                label: x.first_name ? `${x.first_name} ${x.last_name}` : x.email_address,
                            })) || []),
                        ]}
                    />
                </Flex>

                <Flex sx={{ mt: 20, mb: 20, width: 680 }}>
                    <Label sx={{ mt: 0 }} id="overseas-label">
                        Overseas
                    </Label>

                    <Switch
                        aria-labelledby="overseas-label"
                        sx={{ mt: 0, ml: 20 }}
                        defaultChecked={state.overseas}
                        onClick={(e) => updateState({ ...state, overseas: !state.overseas })}
                    />
                </Flex>

                {state?.clientType?.value === 'company' && !state.overseas && (
                    <>
                        <Label sx={{ mt: 10 }} id="comp-number-label">
                            Search for a company
                        </Label>

                        <AsyncSelect
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.2)',
                                    width: '400px',
                                    minHeight: '40px',
                                    marginTop: '10px',
                                    borderRadius: 10,
                                    marginBottom: '10px',
                                    border: '1px solid #a3a69b',
                                    fontSize: '14px',
                                }),
                            }}
                            aria-labelledby="client-label"
                            onChange={async (c) => {
                                updateState({ ...state, companyId: c.value });
                            }}
                            placeholder="Search for a client by company name"
                            value={state.searchByCompanyName}
                            loadOptions={loadCompaniesAsync(state, updateState)}
                        />

                        <Label sx={{ mt: 10 }} id="comp-number-label">
                            Company number
                        </Label>

                        <Input
                            aria-labelledby="comp-number-label"
                            sx={{
                                mt: '10px',
                                mb: '25px',
                                width: '400px',
                                background: '#FFFFFF',
                                border: errorState?.companyId ? '1px solid red' : '1px solid #a3a69b',
                                borderRadius: '10px',
                                height: '40px',
                                fontSize: '14px',
                            }}
                            type="text"
                            id="company_id"
                            data-testid="company_id"
                            name="company_id"
                            label=""
                            value={state?.companyId}
                            placeholder="From companies house, e.g. 12978156"
                            onChange={(e) => updateState({ ...state, companyId: e.target.value })}
                            error={null}
                        />
                    </>
                )}

                {(state?.clientType?.value === 'individual' || state.overseas) && (
                    <>
                        <Label sx={{ mt: 10 }} id="client-name-label">
                            Client Name
                        </Label>

                        <Input
                            aria-labelledby="client-name-label"
                            sx={{
                                mt: '10px',
                                mb: '15px',
                                width: '400px',
                                background: '#FFFFFF',
                                border: errorState?.individualName ? '1px solid red' : '1px solid #a3a69b',
                                borderRadius: '10px',
                                height: '40px',
                                fontSize: '14px',
                            }}
                            type="text"
                            id="individualName"
                            data-testid="individualName"
                            name="individualName"
                            label=""
                            value={state?.individualName}
                            placeholder="Enter the client's name"
                            onChange={(e) => updateState({ ...state, individualName: e.target.value })}
                            error={null}
                        />
                    </>
                )}

                <Flex sx={{ mt: 20, mb: state.autoGenerateClientCode ? 30 : 0 }}>
                    <Label sx={{ mt: 0, width: 250 }} id="urn-label">
                        Client Code
                    </Label>
                    <Flex>
                        <Label sx={{ mt: 0, width: 200 }} id="auto-gen-client-code-label">
                            Auto generate
                        </Label>

                        <Switch
                            aria-labelledby="auto-gen-client-code-label"
                            sx={{ mt: 0, ml: 0 }}
                            defaultChecked={state.autoGenerateClientCode}
                            onClick={(e) =>
                                updateState({ ...state, autoGenerateClientCode: !state.autoGenerateClientCode })
                            }
                        />
                    </Flex>
                </Flex>

                {!state.autoGenerateClientCode && (
                    <Input
                        aria-labelledby="urn-label"
                        sx={{
                            mt: '10px',
                            mb: '25px',
                            width: '400px',
                            background: '#FFFFFF',
                            borderRadius: '10px',
                            height: '40px',
                            fontSize: '14px',
                            border: errorState?.internal_reference_code ? '1px solid red' : '1px solid #a3a69b',
                        }}
                        type="text"
                        id="internal_reference_code"
                        data-testid="internal_reference_code"
                        name="internal_reference_code"
                        label=""
                        value={state?.internal_reference_code}
                        placeholder="For internal use, e.g. CC12515"
                        onChange={(e) => updateState({ ...state, internal_reference_code: e.target.value })}
                        error={null}
                    />
                )}

                <Flex sx={{ width: 680 }}>
                    <Label sx={{ mt: 0 }} id="vat-reg-label">
                        VAT registered
                    </Label>

                    <Switch
                        aria-labelledby="vat-reg-label"
                        sx={{ mt: 0, ml: 20 }}
                        defaultChecked={state.vat_registered}
                        onClick={(e) => updateState({ ...state, vat_registered: !state.vat_registered })}
                    />
                </Flex>

                {state.vat_registered && (
                    <Flex sx={{ flexDirection: 'column', mt: 20 }}>
                        <Label sx={{ mt: 0 }} id="vat-no-label">
                            VAT number
                        </Label>
                        <Input
                            aria-labelledby="vat-no-label"
                            sx={{
                                mt: '10px',
                                mb: '25px',
                                width: '400px',
                                background: '#FFFFFF',
                                border: errorState?.vat_number ? '1px solid red' : '1px solid #a3a69b',
                                borderRadius: '10px',
                                height: '40px',
                                fontSize: '14px',
                            }}
                            type="text"
                            id="vat_number"
                            data-testid="vat_number"
                            name="vat_number"
                            label=""
                            value={state?.vat_number}
                            placeholder="Enter your vat number"
                            onChange={(e) => updateState({ ...state, vat_number: e.target.value })}
                            error={null}
                        />
                    </Flex>
                )}

                <Flex sx={{ height: 1, mt: 30, mb: 30, borderTop: '1px solid #CCC' }} />

                <Title text="Services" subtitle="" />
                <Flex sx={{ height: 20 }} />

                {Object.entries(state.organisation?.workflow_definition?.services || {}).map(([key, value]) => {
                    return (
                        <Flex sx={{ mb: 20, width: 1100 }}>
                            <Label sx={{ width: 500, fontSize: 14, mr: 20 }} id={`${key}-label`}>
                                {value.label}
                            </Label>
                            <Switch
                                aria-labelledby={`${key}-label`}
                                sx={{ cursor: 'pointer' }}
                                defaultChecked={state?.newClientServicesOffered?.[key]}
                                onClick={() => {
                                    const newMap = { ...state.newClientServicesOffered };

                                    newMap[key] = state.newClientServicesOffered[key] ? false : true;

                                    updateState({ ...state, newClientServicesOffered: newMap });
                                }}
                            />
                        </Flex>
                    );
                })}

                <Flex
                    sx={{
                        position: 'fixed',
                        height: 80,
                        background: 'white',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        alignItems: 'center',
                        borderTop: '2px solid #EFEFEF',
                        width: '100%',
                        zIndex: 998,
                    }}
                >
                    <Flex
                        sx={{
                            justifyContent: 'space-between',
                        }}
                    >
                        <Button
                            variant="light"
                            sx={{
                                width: '180px',
                                mt: '0',
                                mr: 20,
                                ml: 20,
                            }}
                            data-testid="submit"
                            onClick={async () => {
                                updateState({
                                    ...state,
                                    mode: 'list',
                                    error: null,
                                    companyId: null,
                                    internal_reference_code: null,
                                    vat_registered: false,
                                    vat_number: '',
                                    newClientServicesOffered: {},
                                });
                                updateErrorState(defaultErrorState);
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                            }}
                        >
                            <i
                                style={{
                                    marginTop: '0px',
                                    marginRight: '9px',
                                }}
                                className={`fas fa-times-circle`}
                            />
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            sx={{
                                width: '180px',
                                mt: '0',
                                alignSelf: 'flex-end',
                                backgroundColor: 'primary',
                            }}
                            data-testid="submit"
                            onClick={async () => await createClient(state, updateState, errorState, updateErrorState)}
                        >
                            <i
                                style={{
                                    marginTop: '0px',
                                    marginRight: '9px',
                                }}
                                className={`fas fa-plus-circle`}
                            />
                            Create
                        </Button>
                    </Flex>
                </Flex>
            </Flex>
        </Flex>
    );
};

export const filterDocuments = async (state, updateState, partialLoading = false) => {
    updateState({ ...state, loading: !partialLoading, partialLoading: true });
    const { clientSearchName, clientSearchFilters } = state;
    const name = clientSearchName !== '' ? clientSearchName : '';

    const { clientsOffset, clientsLimit } = state;

    const sortByKeys = [];
    const sortByDirections = [];
    state.client_sort_by?.forEach((item) => {
        const [key, direction] = item.value.split('_');
        if (['name', 'type', 'internalReferenceCode', 'tasks_count'].includes(key)) {
            sortByKeys.push(key);
            sortByDirections.push(direction.toUpperCase());
        }
    });

    const {
        clients,
        total: clientsTotal,
        organisation,
    } = await loadClients(
        state,
        clientsOffset,
        clientsLimit,
        name,
        state.clientTypeFilter?.value,
        state.include_archived,
        sortByKeys.join(','),
        sortByDirections.join(',')
    );

    return updateState({ ...state, loading: false, partialLoading: false, clients, clientsTotal, organisation });
};

export const Filters = ({ state, updateState, type, mini = false, columnOptions, sortByOptions }) => {
    const handleDescriptionChange = debounce(async (e) => {
        const tempState = { ...state, clientSearchName: e.target.value, clientsOffset: 0 };
        updateState(tempState);
        await filterDocuments(tempState, updateState, mini, type);
    }, 500);

    return (
        <Flex sx={{ flexDirection: 'column' }}>
            <Flex sx={{}}>
                <Flex sx={{ flexDirection: 'column' }}>
                    <Label id="fn-label" sx={{ width: 200, mb: '5px' }}>
                        Client name or code
                    </Label>
                    <Input
                        sx={{
                            mb: '25px',
                            width: '300px',
                            background: '#FFFFFF',
                            border: '1px solid #a3a69b',
                            borderRadius: '10px',
                            height: '42px',
                            fontSize: '14px',
                        }}
                        aria-labelledby="fn-label"
                        type="text"
                        id="clientSearchName"
                        data-testid="clientSearchName"
                        name="clientSearchName"
                        label=""
                        placeholder={'Search by client name'}
                        onChange={handleDescriptionChange}
                        error={null}
                    />
                </Flex>
                <Flex sx={{ flexDirection: 'column', ml: 10 }}>
                    <Label id="ct-label" sx={{ width: 200, mb: '5px' }}>
                        Client type
                    </Label>
                    <ReactSelect
                        styles={{
                            control: (provided) => ({
                                ...provided,
                                boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.2)',
                                width: '300px',
                                minHeight: '42px',
                                borderRadius: 10,
                                marginBottom: '10px',
                                border: '1px solid #a3a69b',
                                fontSize: '14px',
                            }),
                        }}
                        aria-labelledby="ct-label"
                        onChange={(c) => {
                            updateState({
                                ...state,
                                clientsOffset: 0,
                                clientTypeFilter: c,
                            });
                        }}
                        placeholder="Select the client type"
                        value={
                            state.clientTypeFilter || {
                                value: 'all',
                                label: 'All client types',
                            }
                        }
                        options={[
                            {
                                value: 'all',
                                label: 'All client types',
                            },
                            {
                                value: 'company',
                                label: 'Companies',
                            },
                            {
                                value: 'individual',
                                label: 'Individuals',
                            },
                        ]}
                    />
                </Flex>
                <Flex sx={{ ml: 10, mb: 20 }}>
                    <Flex sx={{ flexDirection: 'column' }}>
                        <Label sx={{ mb: '5px' }}>Columns</Label>
                        <ReactSelect
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.2)',
                                    width: '350px',
                                    minHeight: '42px',
                                    borderRadius: 10,
                                    marginBottom: '10px',
                                    border: '1px solid #a3a69b',
                                    fontSize: '14px',
                                }),
                            }}
                            isMulti
                            onChange={(c) => {
                                updateState({
                                    ...state,
                                    columns: c?.map((x) => x.value) || [],
                                });
                                localStorage.setItem('client_columns', JSON.stringify(c));
                            }}
                            placeholder="Select the columns"
                            value={state.columns?.map((x) => columnOptions?.find((y) => y.value === x))}
                            options={columnOptions}
                        />
                    </Flex>
                    <Flex sx={{ flexDirection: 'column', ml: 10 }}>
                        <Label sx={{ mb: '5px' }}>Sort By</Label>
                        <ReactSelect
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.2)',
                                    width: '350px',
                                    minHeight: '42px',
                                    borderRadius: 10,
                                    marginBottom: '10px',
                                    border: '1px solid #a3a69b',
                                    fontSize: '14px',
                                }),
                            }}
                            isMulti
                            onChange={(c) => {
                                updateState({
                                    ...state,
                                    client_sort_by: c,
                                });
                                localStorage.setItem('client_sort_by', JSON.stringify(c));
                            }}
                            placeholder="Select the columns"
                            value={state.client_sort_by}
                            options={sortByOptions}
                        />
                    </Flex>
                </Flex>
            </Flex>
            {state.showAdvancedFilter ? (
                <Flex>
                    <Flex sx={{ flexDirection: 'column', mb: 20, mr: 10 }}>
                        <Label id="arc-label" sx={{ width: 200, mb: '5px' }}>
                            Filter on custom attribute
                        </Label>
                        <ReactSelect
                            isClearable
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.2)',
                                    width: '300px',
                                    minHeight: '42px',
                                    borderRadius: 10,
                                    marginBottom: '10px',
                                    border: '1px solid #a3a69b',
                                    fontSize: '14px',
                                }),
                            }}
                            onChange={(c) => {
                                updateState({
                                    ...state,
                                    customColumn: c,
                                    customColumnOperator:
                                        c?.type === 'dropdown'
                                            ? { value: '=', label: '=' }
                                            : state.customColumnOperator,
                                });
                            }}
                            placeholder="Select the custom column"
                            value={state.customColumn}
                            options={
                                Object.entries(state.organisation?.schema || {})?.map((x) => ({
                                    value: x[0],
                                    label: x[1]?.label,
                                    type: x[1]?.type,
                                    dropdownOptions: x[1]?.dropdownOptions,
                                })) || []
                            }
                        />
                        <Flex>
                            {state.customColumn ? (
                                <Flex sx={{ width: 100 }}>
                                    <ReactSelect
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.2)',
                                                width: '90px',
                                                minHeight: '42px',
                                                borderRadius: 10,
                                                marginBottom: '10px',
                                                border: '1px solid #a3a69b',
                                                fontSize: '14px',
                                            }),
                                        }}
                                        onChange={(c) => {
                                            updateState({
                                                ...state,
                                                customColumnOperator: c,
                                            });
                                        }}
                                        placeholder="="
                                        value={state.customColumnOperator}
                                        defaultValue={{
                                            value: '=',
                                            label: '=',
                                        }}
                                        options={[
                                            {
                                                value: '<=',
                                                label: '<=',
                                            },
                                            {
                                                value: '<',
                                                label: '<',
                                            },
                                            {
                                                value: '=',
                                                label: '=',
                                            },
                                            {
                                                value: 'ilike',
                                                label: 'LIKE',
                                            },
                                            {
                                                value: '>',
                                                label: '>',
                                            },
                                            {
                                                value: '>=',
                                                label: '>=',
                                            },
                                        ]}
                                    />
                                </Flex>
                            ) : null}

                            {state.customColumn && ['date', 'string'].includes(state.customColumn?.type) ? (
                                <Input
                                    onChange={debounce(async (e) => {
                                        updateState({
                                            ...state,
                                            customColumnFilterValue: e.target.value,
                                        });
                                    }, 400)}
                                    type={state.customColumn?.type === 'string' ? 'text' : state.customColumn?.type}
                                    placeholder="Filter value"
                                    sx={{ height: 40, width: 200 }}
                                />
                            ) : null}

                            {state.customColumn && ['dropdown'].includes(state.customColumn?.type) ? (
                                <ReactSelect
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.2)',
                                            width: '250px',
                                            minHeight: '42px',
                                            borderRadius: 10,
                                            marginBottom: '10px',
                                            border: '1px solid #a3a69b',
                                            fontSize: '14px',
                                        }),
                                    }}
                                    onChange={(c) => {
                                        updateState({
                                            ...state,
                                            customColumnFilterValue: c.value,
                                        });
                                    }}
                                    placeholder="Select option"
                                    options={state.customColumn?.dropdownOptions?.map((x) => ({
                                        value: x.id,
                                        label: x.label,
                                    }))}
                                />
                            ) : null}
                        </Flex>
                    </Flex>
                    <Flex sx={{ flexDirection: 'column', mr: 10 }}>
                        <Label id="preparers-label" sx={{ mr: 30, fontSize: 14, mb: '5px' }}>
                            Default Preparers
                        </Label>
                        <ReactSelect
                            isClearable
                            aria-labelledby="preparers-label"
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.2)',
                                    width: '300px',
                                    minHeight: '42px',
                                    borderRadius: 10,
                                    marginBottom: '10px',
                                    fontSize: '14px',
                                }),
                            }}
                            onChange={async (c) => {
                                updateState({
                                    ...state,
                                    default_preparer: c,
                                });
                            }}
                            placeholder="Select..."
                            value={state.default_preparer}
                            options={[
                                ...state?.users?.map((x) => ({
                                    value: x.raw_id,
                                    label: x.first_name ? `${x.first_name} ${x.last_name}` : x.email_address,
                                })),
                            ]}
                        />
                    </Flex>
                    <Flex sx={{ flexDirection: 'column', mr: 10 }}>
                        <Label id="preparers-label" sx={{ mr: 30, fontSize: 14, mb: '5px' }}>
                            Default Reviewer
                        </Label>
                        <ReactSelect
                            isClearable
                            aria-labelledby="preparers-label"
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.2)',
                                    width: '300px',
                                    minHeight: '42px',
                                    borderRadius: 10,
                                    marginBottom: '10px',
                                    fontSize: '14px',
                                }),
                            }}
                            onChange={async (c) => {
                                updateState({
                                    ...state,
                                    default_reviewer: c,
                                });
                            }}
                            placeholder="Select..."
                            value={state.default_reviewer}
                            options={[
                                ...state?.users?.map((x) => ({
                                    value: x.raw_id,
                                    label: x.first_name ? `${x.first_name} ${x.last_name}` : x.email_address,
                                })),
                            ]}
                        />
                    </Flex>
                    <Flex sx={{ flexDirection: 'column', mr: 10 }}>
                        <Label id="preparers-label" sx={{ mr: 30, fontSize: 14, mb: '5px' }}>
                            Default Partner
                        </Label>
                        <ReactSelect
                            isClearable
                            aria-labelledby="default_partner-label"
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.2)',
                                    width: '300px',
                                    minHeight: '42px',
                                    borderRadius: 10,
                                    marginBottom: '10px',
                                    fontSize: '14px',
                                }),
                            }}
                            onChange={async (c) => {
                                updateState({
                                    ...state,
                                    default_partner: c,
                                });
                            }}
                            placeholder="Select..."
                            value={state.default_partner}
                            options={[
                                ...state?.users?.map((x) => ({
                                    value: x.raw_id,
                                    label: x.first_name ? `${x.first_name} ${x.last_name}` : x.email_address,
                                })),
                            ]}
                        />
                    </Flex>

                    <Flex sx={{ flexDirection: 'row', ml: 20, mt: 25 }}>
                        <Label id="arc-label" sx={{ width: 140 }}>
                            Include archived
                        </Label>
                        <Switch
                            onClick={() => {
                                updateState({
                                    ...state,
                                    include_archived: state.include_archived ? false : true,
                                });
                            }}
                            sx={{ mt: 10 }}
                            checked={state.include_archived}
                        />
                    </Flex>
                </Flex>
            ) : null}
            {state.showAdvancedFilter ? (
                <Flex>
                    <Flex sx={{ flexDirection: 'column', mb: 20, mr: 10 }}>
                        <Label id="arc-label" sx={{ width: 200, mb: '5px' }}>
                            Status
                        </Label>
                        <ReactSelect
                            isClearable
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.2)',
                                    width: '300px',
                                    minHeight: '42px',
                                    borderRadius: 10,
                                    marginBottom: '10px',
                                    border: '1px solid #a3a69b',
                                    fontSize: '14px',
                                }),
                            }}
                            onChange={(c) => {
                                updateState({
                                    ...state,
                                    clientStatus: c,
                                });
                            }}
                            placeholder="Select the client's status"
                            value={state.clientStatus}
                            options={clientStatusOptions}
                        />
                    </Flex>
                </Flex>
            ) : null}
            <Flex
                onClick={() => {
                    window.localStorage.setItem(
                        'show_advanced_client_filters',
                        state.showAdvancedFilter ? 'false' : 'true'
                    );
                    updateState({ ...state, showAdvancedFilter: state.showAdvancedFilter ? false : true });
                }}
                sx={{ mb: 20, alignItems: 'center', cursor: 'pointer' }}
            >
                <Paragraph sx={{ color: 'primary' }}>
                    {state.showAdvancedFilter ? 'Hide Advanced Filters' : 'Show Advanced Filters'}
                </Paragraph>
                <i
                    style={{
                        top: '0px',
                        marginLeft: 10,
                        cursor: 'pointer',
                        color: theme.colors.primary,
                    }}
                    className={`fas fa-chevron-${state.showAdvancedFilter ? 'up' : 'right'}`}
                />
            </Flex>
        </Flex>
    );
};

export const defaultClientColumns = [
    {
        value: 'name',
        label: 'Name',
    },
    {
        value: 'type',
        label: 'Type',
    },
    {
        value: 'internalReferenceCode',
        label: 'Client code',
    },
    {
        value: 'default_preparer',
        label: 'Default Preparer',
    },
    {
        value: 'default_reviewer',
        label: 'Default Reviewer',
    },
    {
        value: 'default_partner',
        label: 'Default Partner',
    },
    {
        value: 'tasks_count',
        label: 'Tasks count',
    },
    {
        value: 'alerts_count',
        label: 'Alerts count',
    },
];

const sortingComparators = [
    { value: 'name_asc', function: (x, y) => x.name?.toLowerCase()?.localeCompare(y.name?.toLowerCase()) },
    { value: 'name_desc', function: (x, y) => y.name?.toLowerCase()?.localeCompare(x.name?.toLowerCase()) },
    { value: 'type_asc', function: (x, y) => x.type?.toLowerCase()?.localeCompare(y.type?.toLowerCase()) },
    { value: 'type_desc', function: (x, y) => y.type?.toLowerCase()?.localeCompare(x.type?.toLowerCase()) },
    {
        value: 'internalReferenceCode_asc',
        function: (x, y) =>
            x.internal_reference_code?.toLowerCase()?.localeCompare(y.internal_reference_code?.toLowerCase()),
    },
    {
        value: 'internalReferenceCode_desc',
        function: (x, y) =>
            y.internal_reference_code?.toLowerCase()?.localeCompare(x.internal_reference_code?.toLowerCase()),
    },
    {
        value: 'default_preparer_asc',
        function: (x, y) =>
            x.relations
                ?.find((x) => x.type === 'assigned_to')
                ?.name?.toLowerCase()
                ?.localeCompare(y.relations?.find((x) => x.type === 'assigned_to')?.name?.toLowerCase()),
    },
    {
        value: 'default_preparer_desc',
        function: (x, y) =>
            y.relations
                ?.find((x) => x.type === 'assigned_to')
                ?.name?.toLowerCase()
                ?.localeCompare(x.relations?.find((x) => x.type === 'assigned_to')?.name?.toLowerCase()),
    },
    {
        value: 'default_reviewer_asc',
        function: (x, y) =>
            x.relations
                ?.find((x) => x.type === 'reviewer')
                ?.name?.toLowerCase()
                ?.localeCompare(y.relations?.find((x) => x.type === 'reviewer')?.name?.toLowerCase()),
    },
    {
        value: 'default_reviewer_desc',
        function: (x, y) =>
            y.relations
                ?.find((x) => x.type === 'reviewer')
                ?.name?.toLowerCase()
                ?.localeCompare(x.relations?.find((x) => x.type === 'reviewer')?.name?.toLowerCase()),
    },
    {
        value: 'default_partner_asc',
        function: (x, y) =>
            x.relations
                ?.find((x) => x.type === 'partner')
                ?.name?.toLowerCase()
                ?.localeCompare(y.relations?.find((x) => x.type === 'partner')?.name?.toLowerCase()),
    },
    {
        value: 'default_partner_desc',
        function: (x, y) =>
            y.relations
                ?.find((x) => x.type === 'partner')
                ?.name?.toLowerCase()
                ?.localeCompare(x.relations?.find((x) => x.type === 'partner')?.name?.toLowerCase()),
    },
    {
        value: 'additional_data_asc',
        function: (x, y, type = 'string') => {
            if (type === 'number') {
                return y - x;
            }
            return x?.toLowerCase()?.localeCompare(y?.toLowerCase());
        },
    },
    {
        value: 'additional_data_desc',
        function: (x, y, type = 'string') => {
            if (type === 'number') {
                return x - y;
            }
            return y?.toLowerCase()?.localeCompare(x?.toLowerCase());
        },
    },
    {
        value: 'tasks_count_desc',
        function: (x, y) => {
            return y.tasks_count - x.tasks_count;
        },
    },
    {
        value: 'tasks_count_asc',
        function: (x, y) => {
            return x.tasks_count - y.tasks_count;
        },
    },
    {
        value: 'alerts_count_desc',
        function: (x, y) => {
            return y.alerts_count - x.alerts_count;
        },
    },
    {
        value: 'alerts_count_asc',
        function: (x, y) => {
            return x.alerts_count - y.alerts_count;
        },
    },
];

export const sortClients = (clients, client_sort_by, organisation) => {
    return clients.sort((a, b) => {
        let finalValue = 0;
        for (const filter of client_sort_by) {
            const keyWithoutDirection = filter?.value?.replace('_asc', '')?.replace('_desc', '');
            const isAdditionalDataFilter = organisation?.schema?.[keyWithoutDirection];

            let result;

            if (isAdditionalDataFilter) {
                let comparator;
                if (filter?.value?.includes('_desc')) {
                    comparator = sortingComparators?.find((x) => x.value === 'additional_data_desc')?.function;
                } else {
                    comparator = sortingComparators?.find((x) => x.value === 'additional_data_asc')?.function;
                }

                result = comparator(
                    a.client_data?.[keyWithoutDirection],
                    b.client_data?.[keyWithoutDirection],
                    isAdditionalDataFilter?.type
                );
            } else {
                const comparator = sortingComparators?.find((x) => x.value === filter.value)?.function;

                if (!comparator) {
                    continue;
                }

                result = comparator(a, b, organisation);
            }

            if (result !== 0) {
                finalValue = result;
                break;
            }
        }

        return finalValue;
    });
};

export const List = ({ state, updateState, isMobile, navigate, type = 'all' }) => {
    const columnOptions = [
        ...defaultClientColumns,
        ...(Object.entries(state.organisation?.schema || {})?.map((x) => ({
            value: x[0],
            label: x[1]?.label,
        })) || []),
    ];

    let sortByOptions = [
        ...([...defaultClientColumns, ...Object.entries(state.organisation?.schema || [])]?.map((x) => [
            {
                value: (x.value || x[0]) + '_asc',
                label: (x.label || x[1]?.label) + ' ascending',
            },
            {
                value: (x.value || x[0]) + '_desc',
                label: (x.label || x[1]?.label) + ' descending',
            },
        ]) || []),
    ].flat();

    useEffect(() => {
        if (state.clients.length) {
            updateState({
                ...state,
                clients: sortClients(state.clients, state.client_sort_by, state.organisation),
            });
        }
    }, [state.client_sort_by, state.clients]);

    return (
        <Flex
            sx={{
                flexDirection: 'column',
                ml: '0px',
                width: '100%',
            }}
        >
            <Flex sx={{ mt: -20 }}>
                <Filters
                    type={type}
                    state={state}
                    updateState={updateState}
                    columnOptions={columnOptions}
                    sortByOptions={sortByOptions}
                />
            </Flex>

            <Flex
                sx={{
                    mt: '0px',
                    minHeight: ['auto', '70px'],
                    border: '0px solid lightGrey',
                    flexDirection: 'column',
                    backgroundColor: 'white',
                    borderTopRightRadius: 0,
                    borderTopLeftRadius: 0,
                }}
            >
                <table style={{ borderCollapse: 'collapse' }}>
                    <thead
                        style={{
                            backgroundColor: theme.colors.primary,
                            color: 'white',
                            cursor: 'pointer',
                            position: 'sticky',
                            top: 0,
                        }}
                    >
                        {state.columns?.includes('name') && (
                            <th style={{ width: 300, textAlign: 'left', padding: 20 }}>Name</th>
                        )}
                        {state.columns?.includes('type') && (
                            <th style={{ width: 100, textAlign: 'left', padding: 20 }}>Type</th>
                        )}
                        {state.columns?.includes('internalReferenceCode') && (
                            <th style={{ width: 200, textAlign: 'left', padding: 20 }}>Client Code</th>
                        )}
                        {state.columns?.includes('company_number') && (
                            <th style={{ width: 200, textAlign: 'left', padding: 20 }}>Company Number</th>
                        )}
                        {state.columns?.includes('default_preparer') && (
                            <th style={{ width: 200, textAlign: 'left', padding: 20 }}>Default Preparer</th>
                        )}
                        {state.columns?.includes('default_reviewer') && (
                            <th style={{ width: 200, textAlign: 'left', padding: 20 }}>Default Reviewer</th>
                        )}
                        {state.columns?.includes('default_partner') && (
                            <th style={{ width: 200, textAlign: 'left', padding: 20 }}>Default Partner</th>
                        )}
                        {state.columns?.includes('tasks_count') && (
                            <th style={{ width: 200, textAlign: 'left', padding: 20 }}>Tasks Count</th>
                        )}
                        {state.columns?.includes('alerts_count') && (
                            <th style={{ width: 200, textAlign: 'left', padding: 20 }}>Alerts Count</th>
                        )}

                        {Object.entries(state.organisation?.schema || {})
                            .filter((x) => state.columns?.includes(x[0]))
                            .sort((a, b) => {
                                const indexA = state.columns.indexOf(a[0]);
                                const indexB = state.columns.indexOf(b[0]);

                                if (indexA > indexB) {
                                    return 1;
                                } else if (indexA < indexB) {
                                    return -1;
                                }
                                return 0;
                            })
                            .map((x) => (
                                <th style={{ width: 200, textAlign: 'left', padding: 20 }}>{x[1].label}</th>
                            ))}
                    </thead>

                    {state.clients.map((item, i) => {
                        return (
                            <TableRowClients
                                isMobile={isMobile}
                                key={`table_row_${i}`}
                                item={item}
                                i={i}
                                navigate={navigate}
                                state={state}
                                updateState={updateState}
                            />
                        );
                    })}
                </table>
            </Flex>
        </Flex>
    );
};

const keyMapping = {
    companyName: 'Company Name',
    company_number: 'Company Number',
    internal_reference_code: 'Client code',
    companyStatus: 'Company Status',
    dateOfCreation: 'Date of Creation',
    jurisdiction: 'Jurisdiction',
    hasSuperSecurePscs: 'Has Super Secure Pscs',
    type: 'Type',
    hasCharges: 'Has Charges',
    hasInsolvencyHistory: 'Has Insolvency History',
    addressLineOne: 'Address Line One',
    addressLineTwo: 'Address Line Two',
    country: 'Country',
    postalCode: 'Post Code',
    region: 'Region',
    nextDue: 'Next Due',
    nextMadeUpTo: 'Next Made Up To',
    overdue: 'Overdue',
    governedBy: 'Governed By',
    name: 'Name',
    legalForm: 'Legal Form',
    registrationNumber: 'Registration Number',
    isOnRegisterInCountryFormedIn: 'Is On Register In Country Formed In',
    filingHistory: 'Filing History',
    locality: 'Locality',
    authentication_code: 'Auth Code',
    registeredOfficeAddress: 'Registered Office Address',
    serviceAddress: 'Service Address',
    confirmationStatement: 'Confirmation Statement',
    foreignCompanyDetails: 'Foreign Company Details',
    billing_responsibility: 'Billing Responsibility',
    client_code: 'Client Code',
    address: 'Address',
    associate: 'Associate',
    manager: 'Manager',
    companyNumber: 'Company Number',
    obligations: 'Obligations',
    sicCodes: 'Sic Codes',
    sicCodeDescriptions: 'Sic Code Descriptions',
    liabilities: 'Liabilities',
    payments: 'Payments',
    penalties: 'Penalties',
    vat_number: 'VAT Number',
    date_example: 'Date Example',
    number_example: 'Number Example',
    periodKey: 'Period Key',
    start: 'Start',
    end: 'End',
    status: 'Status',
    taxPeriod: 'Tax Period',
    originalAmount: 'Original Amount',
    outstandingAmount: 'Outstanding Amount',
    due: 'Due',
    amount: 'Amount',
    received: 'Received',
};

const getKeyMapping = (original) => {
    let valueToReturn = keyMapping[original];
    if (!valueToReturn) {
        return original;
    }
    return valueToReturn;
};

const ArrKeyValue = ({ theKey, theValue }) => (
    <Flex>
        <Paragraph sx={{ fontWeight: '600', mr: '20px', width: '150px', textAlign: 'right' }}>
            {theKey} {' :'}
        </Paragraph>
        <Paragraph sx={{ fontWeight: '500' }}>{theValue}</Paragraph>
    </Flex>
);

const clientDataRootObjectEditableFields = ['internal_reference_code', 'name', 'company_number'];
const rootClientFields = ['internal_reference_code', 'company_number', 'name'];

const NonEditableRow = ({ label, value, idx }) => {
    const bgColor = idx % 2 !== 0 ? 'white' : 'lightGrey';

    return (
        <Flex
            sx={{
                width: '100%',
                minHeight: '80px',
                justifyContent: 'space-between',
                backgroundColor: bgColor,
                borderRadius: 10,
                alignItems: 'center',
            }}
        >
            <Label
                sx={{
                    fontWeight: '500',
                    width: '522px',
                    borderRight: `1px solid lightgray `,
                    ml: '20px',
                    fontSize: '14px',
                }}
            >
                {label}
            </Label>
            <Paragraph
                sx={{
                    textAlign: 'left',
                    pl: '20px',
                    width: '100%',
                    fontSize: '14px',
                }}
            >
                {value}
            </Paragraph>
        </Flex>
    );
};

let companyHouseItems = [];
let clientDataItems = [];
let hmrcItems = [];

const updateData = async (
    state,
    updateState,
    editForm,
    updateEditForm,
    toggleEditing,
    typeOfEditableItem,
    addressValue,
    updateAddress,
    toggleSaving
) => {
    let errors = 0;
    let dataToSend = {};

    let validatorError = '';

    if (typeOfEditableItem === 'address') {
        const { address_line, post_code, country, city } = addressValue;
        if (address_line === '' || post_code === '' || country?.value === '' || city === '') {
            errors++;
        } else {
            dataToSend = {
                address: {
                    address_line,
                    city,
                    country: country || '',
                    post_code,
                },
            };
        }
    } else {
        Object.keys(editForm)?.map((item) => {
            const value = editForm[item];
            dataToSend[item] = value;

            for (const validator of state.organisation?.schema?.[item]?.validators || []) {
                const type = state.organisation?.schema?.[item]?.type;

                let parsedValue = value;
                if (type === 'number') {
                    if (isNaN(parsedValue)) {
                        validatorError = { message: 'Please enter a number', key: item };
                        break;
                    }

                    parsedValue = parseFloat(parsedValue);

                    if (validator.name?.value === 'min_value' && parsedValue < parseFloat(validator.parameter)) {
                        validatorError = { message: `Value must be at least ${validator.parameter}`, key: item };
                    }

                    if (validator.name?.value === 'max_value' && parsedValue > parseFloat(validator.parameter)) {
                        validatorError = {
                            message: `Value must be less than or equal to ${validator.parameter}`,
                            key: item,
                        };
                    }
                }

                if (type === 'string') {
                    if (validator.name?.value === 'min_length' && parsedValue?.length < validator.parameter) {
                        validatorError = {
                            message: `Value must be at least ${validator.parameter} characters`,
                            key: item,
                        };
                    }

                    if (validator.name?.value === 'max_length' && parsedValue?.length > validator.parameter) {
                        validatorError = {
                            message: `Value must be less than ${validator.parameter} characters`,
                            key: item,
                        };
                    }
                }
            }
        });
    }

    if (validatorError) {
        return updateState({
            ...state,
            updateClientError: validatorError?.message,
            showClientData: true,
        });
    }

    toggleSaving(true);

    try {
        await updateClientData(state?.clientInView?.id, dataToSend);
    } catch (e) {
        toggleSaving(false);
        return updateState({
            ...state,
            updateClientError: e?.response?.data?.message,
            showClientData: true,
        });
    }

    const { data } = await axios({
        url: `${process.env.REACT_APP_AQRU_AI_API}/clients/${state?.clientInView?.id}`,
    });

    updateState({
        ...state,
        clientInView: data,
        updateClientError: null,
        error: null,
        showClientData: true,
        servicesOffered: data?.client_data?.new_client_services_offered?.map((x) => {
            const service = data.organisation?.workflow_definition?.services?.[x];
            return {
                value: x,
                label: service?.label,
            };
        }),
    });

    if (typeOfEditableItem === 'address') {
        updateAddress({ ...addressValue, ...dataToSend });
    } else {
        updateEditForm({
            ...editForm,
            ...dataToSend,
            name: data.name,
            internal_reference_code: data.internal_reference_code,
            company_number: data.company_number,
        });
    }

    toggleEditing(false);
    toggleSaving(false);
};

const buildSchemaObject = (schemaKeys) => {
    const initObj = {};
    schemaKeys?.map((item) => {
        if (item === 'address') {
            initObj[item] = {
                address_line: '',
                city: '',
                country: '',
                post_code: '',
            };
        } else {
            initObj[item] = ' ';
        }
    });
    return initObj;
};

const lookNestedItemInObject = (pathChunks, obj) => {
    let dataToRender = obj;
    if (!dataToRender) {
        return null;
    }
    pathChunks?.forEach((x) => {
        dataToRender = dataToRender?.[x];
    });
    return dataToRender;
};

const HMRCWrapper = ({ state, updateState, rawData, hmrcNextSteps }) => {
    const [hmrcState, updateHmrcState] = useState({
        hmrcDataTabInFocus: 'obligations',
        entityInView: { value: 'vat', label: 'VAT' },
    });

    const { HMRCDataLoaded, HMRCRedirectURL } = state;

    if (hmrcNextSteps && hmrcNextSteps !== 'DATA_AVAILABLE') {
        let copy = 'Your HMRC data will appear here soon';
        let showRefreshButton = true;
        if (hmrcNextSteps === 'vat_no_required') {
            showRefreshButton = false;
            copy = 'Please enter a vat number for your client in order us to download your data';
        }
        return (
            <Flex sx={{ width: '100%', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <Paragraph sx={{ mt: '50px', mb: '40px' }}>{copy}</Paragraph>
                {showRefreshButton && (
                    <Button
                        onClick={() => window.location.assign(`/clients?id=${state.clientInView?.id}&tab=hmrc`)}
                        sx={{ mt: -10, width: 100, mb: 20 }}
                    >
                        Refresh
                    </Button>
                )}
            </Flex>
        );
    }

    if (!HMRCDataLoaded) {
        return (
            <Flex sx={{ width: '100%', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <Paragraph sx={{ mt: '50px', mb: '20px' }}>To view this data you must connect to HMRC.</Paragraph>
                <Button
                    variant="primary"
                    sx={{
                        width: '180px',
                        mt: '0',
                        mb: '50px',
                        backgroundColor: 'white',
                        color: 'text',
                        border: '1px solid #0C1B2A',
                    }}
                    data-testid="submit"
                    onClick={async () => {
                        if (!HMRCRedirectURL) {
                            window.location.reload();
                        } else {
                            window.open(HMRCRedirectURL);
                        }
                    }}
                >
                    Connect
                    <i
                        style={{
                            marginTop: '0px',
                            fontSize: '13px',
                            marginLeft: '9px',
                        }}
                        className={`fas fa-external-link-alt`}
                    />
                </Button>
            </Flex>
        );
    }

    const rawHMRC = rawData?.[hmrcState?.entityInView?.value];

    const hmrcKeys = Object.keys(rawHMRC || {});

    if (hmrcKeys?.length > 0) {
        const tabDefinition = HmrcSpec?.[hmrcState?.entityInView?.value]?.[hmrcState.hmrcDataTabInFocus];

        const headers =
            tabDefinition?.type === 'table' ? Object.entries(tabDefinition?.rowSchema).map((x) => x[1]?.label) : [];

        const dataToRender = lookNestedItemInObject(tabDefinition?.path?.split('.'), rawHMRC);

        return (
            <Flex sx={{ width: '100%', flexDirection: 'column', minHeight: '400px' }}>
                <Flex sx={{ ml: 20, flexDirection: 'column' }}>
                    <Heading
                        sx={{
                            fontWeight: '600',
                            fontSize: '20px',
                            color: 'text',
                            textAlign: 'left',
                            mt: '25px',
                            ml: 0,
                        }}
                    >
                        HMRC Data
                    </Heading>
                    <Divider width="1300px" />
                    <Paragraph sx={{ mt: 0, fontWeight: 400, fontSize: 16 }}>Dataset in view</Paragraph>
                    <Flex sx={{ width: 400 }}>
                        <ReactSelect
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.2)',
                                    width: '300px',
                                    minHeight: '40px',
                                    marginTop: '10px',
                                    borderRadius: 10,
                                    marginBottom: '10px',
                                    border: '1px solid #a3a69b',
                                    fontSize: '14px',
                                }),
                            }}
                            onChange={async (value) => {
                                updateHmrcState({ ...hmrcState, entityInView: value });
                            }}
                            placeholder={'Select the dataset you wish to view'}
                            value={hmrcState.entityInView}
                            options={[{ value: 'vat', label: 'VAT' }]}
                        />
                    </Flex>
                    {rawHMRC?.last_updated && (
                        <Paragraph sx={{ mt: 10, mb: 10 }}>
                            Last updated: {moment(rawHMRC?.last_updated).format('HH:mm Do MMMM YYYY')}
                        </Paragraph>
                    )}
                    <Flex>
                        <Button
                            onClick={async () => {
                                await triggerUpdate(state, updateState, 'download_hmrc', 'showHmrcDownloadWarning');
                            }}
                            sx={{ height: 40, width: 200 }}
                        >
                            Trigger Download
                        </Button>
                    </Flex>
                    <Flex>
                        {HmrcSpec?.[hmrcState.entityInView?.value]?.tabs?.map((tab, idx) => (
                            <Paragraph
                                onClick={() => updateHmrcState({ ...hmrcState, hmrcDataTabInFocus: tab.type })}
                                sx={{
                                    borderLeft: idx === 0 ? '1px solid lightGrey' : '',
                                    borderRight: '1px solid lightGrey',
                                    borderTop: '1px solid lightGrey',
                                    borderBottom: `1px solid ${
                                        hmrcState.hmrcDataTabInFocus === tab.type ? '#FFF' : 'lightGrey'
                                    }`,
                                    mt: 20,
                                    cursor: 'pointer',
                                    padding: 20,
                                    fontWeight: '400',
                                    textAlign: 'center',
                                    width: 150,
                                    backgroundColor: hmrcState.hmrcDataTabInFocus === tab.type ? '#FFF' : 'lightGrey',
                                }}
                            >
                                {tab.label}
                            </Paragraph>
                        ))}
                    </Flex>

                    {tabDefinition?.type === 'facts' && (
                        <Flex sx={{ flexDirection: 'column' }}>
                            {dataToRender ? (
                                Object.entries(tabDefinition?.rowSchema).map((s) => {
                                    let cellValue = lookNestedItemInObject(s[1].path?.split('.'), dataToRender);
                                    return (
                                        <Flex
                                            sx={{
                                                alignItems: 'center',
                                                mt: 20,
                                                width: 600,
                                                justifyContent: 'space-between',
                                            }}
                                        >
                                            <Flex sx={{ ml: 10, fontWeight: 400, fontSize: 14 }}>{s[1].label}</Flex>
                                            <Flex sx={{ fontSize: 14 }}>{cellValue}</Flex>
                                        </Flex>
                                    );
                                })
                            ) : (
                                <Paragraph>
                                    {tabDefinition?.label ? `No ${tabDefinition?.label}` : 'None'} currently
                                </Paragraph>
                            )}
                        </Flex>
                    )}

                    {tabDefinition?.type === 'table' && (
                        <table style={{ marginTop: 20, marginBottom: 20, marginRight: 20 }}>
                            <tr style={{ backgroundColor: theme.colors.lightGrey }}>
                                {headers?.map((h) => (
                                    <td style={{ padding: 15, textAlign: 'center', fontSize: 14 }}>{h}</td>
                                ))}
                            </tr>
                            {(tabDefinition?.listTransformer
                                ? tabDefinition?.listTransformer(dataToRender)
                                : dataToRender
                            )?.map((d) => (
                                <tr>
                                    {Object.entries(tabDefinition?.rowSchema).map((s) => {
                                        const transformer = s[1].transformer || ((val) => val);

                                        let cellValue = lookNestedItemInObject(s[1].path?.split('.'), d);

                                        if (s[1].type === 'date') {
                                            cellValue = moment.utc(cellValue, s[1].format).format('Do MMM YYYY');
                                        }
                                        if (s[1].type === 'decimal') {
                                            cellValue = new Intl.NumberFormat('en-US', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 3,
                                            }).format(cellValue);
                                        }

                                        return (
                                            <td style={{ padding: 15, fontSize: 14, textAlign: 'center' }}>
                                                {transformer(cellValue)}
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))}
                        </table>
                    )}
                </Flex>
            </Flex>
        );
    } else {
        return null;
    }
};

const buildCompaniesHouseElements = (data, editMode = false, state, updateState) => {
    companyHouseItems = [];
    const itemsToExtract = [
        { label: 'Company name', path: 'companyName', type: 'text' },
        { label: 'Company number', path: 'companyNumber', type: 'text' },
        { label: 'Company status', path: 'companyStatus', type: 'text' },
        { label: 'Registered office address', type: 'address', path: 'registeredOfficeAddress' },
        { label: 'Date of creation', type: 'date', path: 'dateOfCreation' },
        { label: '' },
        { label: 'Accounts' },
        {
            label: <p style={{ marginLeft: 10 }}>next accounts start</p>,
            type: 'date',
            path: 'accounts.nextAccounts.periodStartOn',
        },
        {
            label: <p style={{ marginLeft: 10 }}>next accounts end</p>,
            type: 'date',
            path: 'accounts.nextAccounts.periodEndOn',
        },
        { label: <p style={{ marginLeft: 10 }}>next due</p>, type: 'date', path: 'accounts.nextDue' },
        { label: <p style={{ marginLeft: 10 }}>overdue</p>, type: 'boolean', path: 'accounts.overdue' },
        { label: '' },
        { label: 'Confirmation statement' },
        {
            label: <p style={{ marginLeft: 10 }}>last made up to</p>,
            type: 'date',
            path: 'confirmationStatement.lastMadeUpTo',
        },
        { label: <p style={{ marginLeft: 10 }}>next due</p>, type: 'date', path: 'confirmationStatement.nextDue' },
        {
            label: <p style={{ marginLeft: 10 }}>next made up to</p>,
            type: 'date',
            path: 'confirmationStatement.nextMadeUpTo',
        },
        { label: <p style={{ marginLeft: 10 }}>overdue</p>, type: 'boolean', path: 'confirmationStatement.overdue' },
        { label: '' },
        { label: 'Date of creation', type: 'date', path: 'dateOfCreation' },
        { label: 'Has insolvency history', type: 'boolean', path: 'hasInsolvencyHistory' },
        { label: 'Has super secure pscs', type: 'boolean', path: 'hasSuperSecurePscs' },
        { label: 'Is on register in country formed in', type: 'boolean', path: 'isOnRegisterInCountryFormedIn' },
        { label: 'Jurisdiction', path: 'jurisdiction' },

        { label: 'Sic codes', path: 'sicCodes', type: 'array' },
        { label: 'Sic code descriptions', path: 'sicCodeDescriptions', type: 'array' },
        { label: 'Type', path: 'type', type: 'text' },
    ];

    for (let index = 0; index < itemsToExtract.length; index++) {
        const { label, path, type } = itemsToExtract[index];
        const segments = path?.split('.') || [];

        let value = segments.reduce((accum, item) => {
            return accum?.[item];
        }, data);

        if (!path) {
            value = '';
        }

        if (type === 'boolean' && typeof value === 'boolean' && !editMode) {
            value = value ? 'yes' : 'no';
        }

        if (type === 'array' && value && !editMode && Array.isArray(value)) {
            value = value.join(', ');
        }

        if (type === 'date' && value && !editMode) {
            value = moment.utc(value).format('Do MMMM YYYY');
        }

        if (type === 'address' && value && !editMode) {
            value = (
                <Flex sx={{ flexDirection: 'column', padding: '20px 0px' }}>
                    <Paragraph>{value.addressLineOne || ''}</Paragraph>
                    <Paragraph>{value.addressLineTwo || ''}</Paragraph>
                    <Paragraph>{value.locality || ''}</Paragraph>
                    <Paragraph>{value.postalCode || ''}</Paragraph>
                    <Paragraph>{value.country || ''}</Paragraph>
                </Flex>
            );
        }

        if (editMode) {
            if (type === 'boolean') {
                companyHouseItems.push(
                    <Flex
                        sx={{
                            alignItems: 'center',
                            mt: '10px',
                            mb: 10,
                            ml: 20,
                            justifyContent: 'flex-start',
                        }}
                    >
                        <Label sx={{ width: 270 }}>{label}</Label>
                        <Switch
                            onClick={(e) => {
                                const profile = state?.companiesHouseData || {};

                                setValueByPath(profile || {}, path, !value);

                                updateState({
                                    ...state,
                                    companiesHouseData: {
                                        ...profile,
                                    },
                                });
                            }}
                            sx={{}}
                            defaultChecked={value}
                        />
                    </Flex>
                );
            }
            if (type === 'date') {
                companyHouseItems.push(
                    <Flex
                        sx={{
                            alignItems: 'center',
                            mt: '10px',
                            mb: 10,
                            ml: 20,
                            justifyContent: 'flex-start',
                        }}
                    >
                        <Label sx={{ width: 220 }}>{label}</Label>
                        <Input
                            onChange={(e) => {
                                const profile = state?.companiesHouseData || {};

                                setValueByPath(profile || {}, path, e.target.value);

                                updateState({
                                    ...state,
                                    companiesHouseData: {
                                        ...profile,
                                    },
                                });
                            }}
                            sx={{ width: 200 }}
                            type="date"
                            defaultValue={value}
                        />
                    </Flex>
                );
            }
            if (type === 'address') {
                companyHouseItems.push(
                    <Flex
                        sx={{
                            mt: '10px',
                            mb: 10,
                            ml: 20,
                            justifyContent: 'flex-start',
                        }}
                    >
                        <Label sx={{ width: 220, mt: 20 }}>{label}</Label>
                        <Flex sx={{ flexDirection: 'column', padding: '20px 0px' }}>
                            <Label sx={{ mb: '5px' }}>Address Line 1</Label>
                            <Input
                                onChange={(e) => {
                                    const profile = state?.companiesHouseData || {};

                                    setValueByPath(profile || {}, path + '.addressLineOne', e.target.value);

                                    updateState({
                                        ...state,
                                        companiesHouseData: {
                                            ...profile,
                                        },
                                    });
                                }}
                                sx={{ mb: 10, width: 250 }}
                                defaultValue={value?.addressLineOne || ''}
                            />
                            <Label sx={{ mb: '5px' }}>Address Line 2</Label>
                            <Input
                                onChange={(e) => {
                                    const profile = state?.companiesHouseData || {};

                                    setValueByPath(profile || {}, path + '.addressLineTwo', e.target.value);

                                    updateState({
                                        ...state,
                                        companiesHouseData: {
                                            ...profile,
                                        },
                                    });
                                }}
                                sx={{ mb: 10, width: 250 }}
                                defaultValue={value?.addressLineTwo || ''}
                            />
                            <Label sx={{ mb: '5px' }}>Address Line 3</Label>
                            <Input
                                onChange={(e) => {
                                    const profile = state?.companiesHouseData || {};

                                    setValueByPath(profile || {}, path + '.locality', e.target.value);

                                    updateState({
                                        ...state,
                                        companiesHouseData: {
                                            ...profile,
                                        },
                                    });
                                }}
                                sx={{ mb: 10, width: 250 }}
                                defaultValue={value?.locality || ''}
                            />
                            <Label sx={{ mb: '5px' }}>Postcode</Label>
                            <Input
                                onChange={(e) => {
                                    const profile = state?.companiesHouseData || {};

                                    setValueByPath(profile || {}, path + '.postalCode', e.target.value);

                                    updateState({
                                        ...state,
                                        companiesHouseData: {
                                            ...profile,
                                        },
                                    });
                                }}
                                sx={{ mb: 10, width: 250 }}
                                defaultValue={value?.postalCode || ''}
                            />
                            <Label sx={{ mb: '5px' }}>Country</Label>
                            <Input
                                onChange={(e) => {
                                    const profile = state?.companiesHouseData || {};

                                    setValueByPath(profile || {}, path + '.country', e.target.value);

                                    updateState({
                                        ...state,
                                        companiesHouseData: {
                                            ...profile,
                                        },
                                    });
                                }}
                                sx={{ width: 250 }}
                                defaultValue={value?.country || ''}
                            />
                        </Flex>
                    </Flex>
                );
            }
            if (type === 'text') {
                companyHouseItems.push(
                    <Flex
                        sx={{
                            alignItems: 'center',
                            mt: '10px',
                            mb: 10,
                            ml: 20,
                            justifyContent: 'flex-start',
                        }}
                    >
                        <Label sx={{ width: 220 }}>{label}</Label>
                        <Input
                            onChange={(e) => {
                                const profile = state?.companiesHouseData || {};

                                setValueByPath(profile || {}, path, e.target.value);

                                updateState({
                                    ...state,
                                    companiesHouseData: {
                                        ...profile,
                                    },
                                });
                            }}
                            sx={{ width: 450 }}
                            type="text"
                            value={value}
                        />
                    </Flex>
                );
            }
            if (type === 'array') {
                companyHouseItems.push(
                    <Flex
                        sx={{
                            alignItems: 'center',
                            mt: '10px',
                            mb: 10,
                            ml: 20,
                            justifyContent: 'flex-start',
                        }}
                    >
                        <Label sx={{ width: 220 }}>{label}</Label>
                        <Input
                            onChange={(e) => {
                                const profile = state?.companiesHouseData || {};

                                setValueByPath(profile || {}, path, e.target.value);

                                updateState({
                                    ...state,
                                    companiesHouseData: {
                                        ...profile,
                                    },
                                });
                            }}
                            sx={{ width: 450 }}
                            type="text"
                            defaultValue={value}
                        />
                    </Flex>
                );
            }
            if (!type) {
                companyHouseItems.push(
                    <Flex
                        sx={{
                            alignItems: 'center',
                            mt: '10px',
                            mb: 10,
                            ml: 20,
                            justifyContent: 'flex-start',
                        }}
                    >
                        <Label>{label}</Label>
                    </Flex>
                );
            }
        } else {
            companyHouseItems.push(<NonEditableRow idx={index} label={label} value={value || ''} />);
        }
    }
    if (editMode) {
        companyHouseItems = [
            <Button
                onClick={async () => {
                    await saveCompaniesHouseData(state, updateState);
                }}
                sx={{ width: 120, height: 40, ml: 20, mt: 0, mb: 20 }}
            >
                Save
            </Button>,
            ...companyHouseItems,
            <Button
                onClick={async () => {
                    await saveCompaniesHouseData(state, updateState);
                }}
                sx={{ width: 120, height: 40, ml: 240, mt: 40 }}
            >
                Save
            </Button>,
        ];
    }
};

const triggerUpdate = async (state, updateState, task, warningKey) => {
    try {
        updateState({ ...state, loading: true, error: null });

        await axios({
            url: `${process.env.REACT_APP_AQRU_AI_API}/clients/${state.clientInView.id}/force-task`,
            method: 'POST',
            data: {
                task,
            },
        });

        updateState({
            ...state,
            loading: false,
            ...(warningKey ? { [warningKey]: true } : {}),
        });
    } catch (e) {
        updateState({
            ...state,
            loading: false,
            error: 'There has been an error updating the data, please try again later',
        });
    }
};

const companiesHouseSync = async (state, updateState) => {
    try {
        updateState({ ...state, loading: true, error: null });

        await axios({
            url: `${process.env.REACT_APP_AQRU_AI_API}/clients/${state.clientInView.id}/ch-sync`,
            method: 'POST',
        });

        window.location.reload(true);
    } catch (e) {
        updateState({
            ...state,
            loading: false,
            error: 'There has been an error syncing the data, please try again later',
        });
    }
};

export const Edit = ({
    state,
    updateState,
    organisation,
    isMobile,
    navigate,
    errorState,
    updateErrorState,
    stateRef,
    user,
    queryDocument,
}) => {
    const { clientInView } = state;
    const [dataToShow, toggleData] = useState(state.tab || 'client_data'); // companies_house | client_data | hmrc
    const [editableFields, updateEditableFields] = useState([]);

    const loopOverObject = async (obj, type = 'companies_house', i = 0, editableFields, fullSchema, organisation) => {
        try {
            let keysToLoopOver = Object.keys(obj || {});

            for (let key of keysToLoopOver) {
                if (fieldsToIgnoreInRecord.includes(key)) continue;

                if (typeof obj[key] === 'object' && obj[key] !== null) {
                    if (Object.keys(obj[key] || {}).length > 0) {
                        i++;
                    }
                } else {
                    i++;
                }
            }
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        (async () => {
            updateState({ ...state, loading: true, showClientData: false });
            companyHouseItems = [];
            clientDataItems = [];
            hmrcItems = [];

            let HMRCRedirectURL = null;
            let HMRCDataLoaded = false;
            let hmrcNextSteps = '';
            try {
                const { code } = await verifyHMRCToken(state?.clientInView?.id);

                HMRCDataLoaded = true;

                if (code === 'VAT_NO_NOT_SET') {
                    hmrcNextSteps = 'vat_no_required';
                } else {
                    hmrcNextSteps = code;
                }
            } catch (e) {
                console.log(e);
                const { response } = e;
                if (response?.data) {
                    if (response?.data?.code === 'AUTH_REQUIRED') {
                        const url = response?.data?.redirect_uri || false;
                        if (url) {
                            HMRCRedirectURL = url;
                        }
                    } else if (response?.data?.code === 'VAT_NO_NOT_SET') {
                        HMRCDataLoaded = true;
                        hmrcNextSteps = 'vat_no_required';
                    } else {
                        HMRCDataLoaded = false;
                    }
                }
            }

            const { countries } = await loadCountriesAndReturn(state, updateState);

            const mappedCountryList = countries?.map((item) => ({
                value: item?.code,
                label: item?.name,
            }));
            try {
                const [
                    data,
                    {
                        data: { documents, total: totalDocuments },
                    },
                    {
                        data: { comments, total: totalComments },
                    },
                    {
                        data: { users },
                    },
                ] = await Promise.all([
                    getSingleClient(clientInView?.id),
                    axios({
                        url: `${process.env.REACT_APP_AQRU_AI_API}/clients/${state.clientInView.id}/documents`,
                        params: { offset: 0, limit: state.documentsLimit },
                    }),
                    axios({
                        url: `${process.env.REACT_APP_AQRU_AI_API}/clients/${state.clientInView.id}/comments`,
                        params: { offset: 0, limit: state.commentsLimit },
                    }),
                    axios.get(`${process.env.REACT_APP_AQRU_AI_API}/clients/${state.clientInView.raw_id}/users`),
                ]);

                const fullSchema = data?.organisation?.schema || {};

                const newSchema = {};
                Object.entries(fullSchema).forEach((entry) => {
                    const key = entry[0];
                    const value = entry[1];
                    if (!value.client_types || value.client_types?.includes(data.type)) {
                        newSchema[key] = value;
                    }
                });

                const schemaKeys = Object.keys(newSchema);

                updateEditableFields(schemaKeys);

                const profile = data?.companies_house_data?.profile;
                const companiesHouseData = { ...profile };

                buildCompaniesHouseElements(companiesHouseData, state.allowCompaniesHouseEdit, state, updateState);

                let hmrcData;
                if (HMRCDataLoaded) {
                    hmrcData = data?.hmrc_data;
                    loopOverObject(hmrcData?.vat, 'hmrc', 0, schemaKeys, fullSchema);
                }

                updateState({
                    ...state,
                    loading: false,
                    servicesOffered: data?.client_data?.new_client_services_offered?.map((x) => {
                        const service = data.organisation?.workflow_definition?.services?.[x];
                        return {
                            value: x,
                            label: service?.label,
                        };
                    }),
                    documents,
                    comments,
                    clientInView: data,
                    clientUsers: users.map((x) => ({ ...x, loadedFromServer: true })),
                    showClientData: true,
                    reloadAll: false,
                    schemaKeys,
                    fullSchema,
                    HMRCRedirectURL,
                    HMRCDataLoaded,
                    hmrcNextSteps,
                    HMRCRawData: hmrcData,
                    countries: mappedCountryList,
                    totalDocuments,
                    totalComments,
                    companiesHouseData,
                });
            } catch (e) {
                window.location.assign('/clients');
            }
        })();
    }, [
        state?.reloadAll,
        state.clientInView?.internal_reference_code,
        state.clientInView?.name,
        state.clientInView?.company_number,
        state.clientInView?.clientData,
    ]);

    useEffect(() => {
        if (state.totalDocuments === 0 && state.totalComments === 0) return;

        (async () => {
            const [
                {
                    data: { documents, total: totalDocuments },
                },
                {
                    data: { comments, total: totalComments },
                },
            ] = await Promise.all([
                axios({
                    url: `${process.env.REACT_APP_AQRU_AI_API}/clients/${state.clientInView.id}/documents`,
                    params: { offset: state.taskDocumentsOffset, limit: state.documentsLimit },
                }),
                axios({
                    url: `${process.env.REACT_APP_AQRU_AI_API}/clients/${state.clientInView.id}/comments`,
                    params: { offset: state.taskCommentsOffset, limit: state.commentsLimit },
                }),
            ]);

            updateState({
                ...state,
                loading: false,
                documents,
                comments,
                totalDocuments,
                totalComments,
            });
        })();
    }, [state.taskCommentsOffset, state.taskDocumentsOffset]);

    useEffect(() => {
        if (dataToShow !== 'task_config') return;

        (async () => {
            const [
                {
                    data: { relations: clientRelations },
                },
                {
                    data: { users },
                },
            ] = await Promise.all([
                axios({
                    url: `${process.env.REACT_APP_AQRU_AI_API}/clients/${state.clientInView.id}/relations`,
                }),
                axios({
                    url: `${process.env.REACT_APP_AQRU_AI_API}/organisations/users`,
                    params: {
                        limit: 300,
                        offset: 0,
                    },
                }),
            ]);

            updateState({
                ...state,
                loading: false,
                clientRelations,
                users,
                confirmMessage: '',
                defaultPartners: clientRelations
                    ?.filter((x) => x.type === 'partner')
                    ?.map((x) => ({ value: x.id, label: x.email_address })),
                defaultReviewers: clientRelations
                    ?.filter((x) => x.type === 'reviewer')
                    ?.map((x) => ({ value: x.id, label: x.email_address })),
                defaultAssignees: clientRelations
                    ?.filter((x) => x.type === 'assigned_to')
                    ?.map((x) => ({ value: x.id, label: x.email_address })),
            });
        })();
    }, [dataToShow]);

    useEffect(() => {
        buildCompaniesHouseElements(state.companiesHouseData, state.allowCompaniesHouseEdit, state, updateState);
        updateState({ ...state, _refresh: !state._refresh });
    }, [state.allowCompaniesHouseEdit]);

    return (
        <Flex
            sx={{
                minHeight: '450px',
                flexDirection: 'column',
                border: '0px red solid',
                mt: '-30px',
                mb: '10px',
                position: 'relative',
            }}
        >
            {state?.editLoading && <Spinner />}

            <Flex
                sx={{
                    width: '100%',
                    mt: -30,
                    minHeight: '400px',
                    border: '0px red solid',
                    flexDirection: 'column',
                }}
            >
                <Flex sx={{ mb: 20, alignSelf: 'center' }}>
                    <Button
                        sx={{
                            color: '#000',
                            backgroundColor: '#FFF',
                            border: '1px solid lightGrey',
                            height: 40,
                            width: 140,
                            fontSize: 14,
                        }}
                        variant="light"
                        onClick={async () => {
                            if (state.view === 'generate_invoice') {
                                return updateState({
                                    ...state,
                                    view: 'main',
                                    invoice: null,
                                    timeEntryResults: null,
                                    paramsUsedForSearch: null,
                                });
                            }
                            window.location.assign('/clients');
                        }}
                    >
                        <i
                            style={{
                                marginTop: '0px',
                                fontSize: '12px',
                                marginRight: '6px',
                            }}
                            className={`fas fa-chevron-left`}
                        />
                        Clients List
                    </Button>

                    <Button
                        sx={{
                            color: '#000',
                            backgroundColor: '#FFF',
                            border: '1px solid lightGrey',
                            ml: 10,
                            width: 240,
                            height: 40,
                            fontSize: 14,
                        }}
                        onClick={async () => {
                            await companiesHouseSync(state, updateState);
                        }}
                    >
                        <i
                            style={{
                                marginRight: '7px',
                            }}
                            className={`fas fa-sync`}
                        />
                        Companies House Sync
                    </Button>

                    {state.organisation?.quickbooks_setup ? (
                        <Button
                            sx={{
                                color: '#000',
                                backgroundColor: '#FFF',
                                border: '1px solid lightGrey',
                                ml: 10,
                                width: 180,
                                height: 40,
                                fontSize: 14,
                            }}
                            onClick={() => {
                                updateState({ ...state, showQuickbooksSetupModal: true });
                            }}
                        >
                            <QuickbooksImg />
                        </Button>
                    ) : null}

                    {state.organisation?.xero_status === 'connected' ? (
                        <Button
                            sx={{
                                color: '#000',
                                backgroundColor: '#FFF',
                                border: '1px solid lightGrey',
                                ml: 10,
                                width: 180,
                                height: 40,
                                fontSize: 14,
                            }}
                            onClick={() => {
                                updateState({ ...state, showXeroSetupModal: true });
                            }}
                        >
                            <Flex sx={{ ml: 35 }}>
                                <Image sx={{ width: 25, mt: '-2px' }} src="/xero2.png" />
                                <Paragraph sx={{ ml: '5px' }}>Search</Paragraph>
                            </Flex>
                        </Button>
                    ) : null}

                    <Link href={`/tasks?client_id=${state.clientInView?.raw_id}`} target="_blank">
                        <Button sx={{ color: '#FFF', ml: 10, width: 170, height: 40, fontSize: 14 }}>
                            <i
                                style={{
                                    marginTop: '0px',
                                    fontSize: '12px',
                                    marginRight: '6px',
                                }}
                                className={`fas fa-search`}
                            />
                            View client tasks
                        </Button>
                    </Link>
                </Flex>

                <ClientSetupProgressIndicator
                    staffSetup={
                        state?.defaultAssignees?.length &&
                        state?.defaultReviewers?.length &&
                        state?.defaultPartners?.length
                    }
                    contactsSetup={state.clientInView?.client_data?.key_contacts?.length}
                    mandatoryDataSetup={allDataCollected(
                        state.clientInView.organisation,
                        state.clientInView?.client_data,
                        state.clientInView?.type
                    )}
                    switchTab={(tab) => {
                        toggleData(tab);
                        navigate({
                            pathname: window.location.pathname,
                            search: `?id=${state.clientInView.id}&tab=${tab}`,
                        });
                    }}
                />

                {state.updateClientError && (
                    <Paragraph sx={{ color: 'red', mb: 10 }}>{state.updateClientError}</Paragraph>
                )}

                {state.showDeleteCommentConfirmation && (
                    <ConfirmDialog
                        updateState={updateState}
                        state={state}
                        stateKey="showDeleteCommentConfirmation"
                        text="Are you sure you wish to delete this comment?"
                    />
                )}

                {state.showQuickbooksSetupModal ? (
                    <Overlay
                        copy={{}}
                        maxWidth={500}
                        maxHeight={450}
                        embeddedComponent={<QuickbooksLinkOverlay state={state} updateState={updateState} />}
                        updateOverlay={() => updateState({ ...state, showQuickbooksSetupModal: false })}
                    />
                ) : null}

                {state.showXeroSetupModal ? (
                    <Overlay
                        copy={{}}
                        maxWidth={500}
                        maxHeight={450}
                        embeddedComponent={<XeroLinkOverlay state={state} updateState={updateState} />}
                        updateOverlay={() => updateState({ ...state, showXeroSetupModal: false })}
                    />
                ) : null}

                {state.showHmrcDownloadWarning && (
                    <ConfirmDialog
                        updateState={updateState}
                        state={state}
                        showOkOnly
                        stateKey="showHmrcDownloadWarning"
                        text="The download will complete in the next few minutes"
                    />
                )}

                {state.showDeleteClientConfirmation && (
                    <ConfirmDialog
                        updateState={updateState}
                        state={state}
                        stateKey="showDeleteClientConfirmation"
                        text="Are you sure you wish to delete this client?"
                    />
                )}

                {state.showDeleteDocumentConfirmation && (
                    <ConfirmDialog
                        updateState={updateState}
                        state={state}
                        stateKey="showDeleteDocumentConfirmation"
                        text="Are you sure you wish to delete this document?"
                    />
                )}

                {state.view === 'generate_invoice' && <GenerateInvoice state={state} updateState={updateState} />}

                {state.view === 'main' && (
                    <Flex sx={{ alignSelf: 'center' }}>
                        <Flex
                            sx={{
                                minHeight: '100px',
                                borderBottom: '0px solid lightgray',
                                pb: '40px',
                                mb: '30px',
                                mt: '10px',
                                flexDirection: 'column',
                                // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.5)',
                                // borderTopLeftRadius: 10,
                                // borderTopRightRadius: 10,
                            }}
                        >
                            <Flex
                                sx={{
                                    mb: '0',
                                    pb: '0',
                                    width: '1300px',
                                    height: '60px',
                                    borderRadius: '10px',
                                    borderBottom: '1px solid lightgray',
                                    borderBottomLeftRadius: 0,
                                    borderBottomRightRadius: 0,
                                    ml: '5px',
                                    mt: '5px',
                                    mr: '5px',
                                }}
                            >
                                <Flex
                                    sx={{
                                        flex: 1,
                                        textAlign: 'center',
                                        alignSelf: 'center',
                                        cursor: 'pointer',
                                        height: 60,
                                        borderBottom: dataToShow === 'client_data' ? '6px solid #e8b923' : 'unset',
                                    }}
                                    onClick={() => {
                                        toggleData('client_data');
                                        navigate({
                                            pathname: window.location.pathname,
                                            search: `?id=${state.clientInView.id}&tab=client_data`,
                                        });
                                    }}
                                >
                                    <Paragraph
                                        sx={{
                                            textAlign: 'center',
                                            width: '100%',
                                            fontSize: '15px',
                                            alignSelf: 'center',
                                            fontWeight: dataToShow === 'client_data' ? '400' : '300',
                                        }}
                                    >
                                        Client Data
                                    </Paragraph>
                                </Flex>
                                <Flex
                                    sx={{
                                        flex: 1,
                                        textAlign: 'center',
                                        alignSelf: 'center',
                                        height: 60,
                                        cursor: 'pointer',
                                        borderBottom: dataToShow === 'task_config' ? '6px solid #e8b923' : 'unset',
                                    }}
                                    onClick={() => {
                                        toggleData('task_config');
                                        navigate({
                                            pathname: window.location.pathname,
                                            search: `?id=${state.clientInView.id}&tab=task_config`,
                                        });
                                    }}
                                >
                                    <Paragraph
                                        sx={{
                                            textAlign: 'center',
                                            width: '100%',
                                            fontSize: '15px',
                                            alignSelf: 'center',
                                            fontWeight: dataToShow === 'task_config' ? '400' : '300',
                                        }}
                                    >
                                        Staff
                                    </Paragraph>
                                </Flex>
                                <Flex
                                    sx={{
                                        flex: 1,
                                        textAlign: 'center',
                                        alignSelf: 'center',
                                        cursor: 'pointer',
                                        height: 60,
                                        borderBottom: dataToShow === 'key_contacts' ? '6px solid #e8b923' : 'unset',
                                    }}
                                    onClick={() => {
                                        toggleData('key_contacts');
                                        navigate({
                                            pathname: window.location.pathname,
                                            search: `?id=${state.clientInView.id}&tab=key_contacts`,
                                        });
                                    }}
                                >
                                    <Paragraph
                                        sx={{
                                            textAlign: 'center',
                                            width: '100%',
                                            fontSize: '15px',
                                            alignSelf: 'center',
                                            fontWeight: dataToShow === 'key_contacts' ? '400' : '300',
                                        }}
                                    >
                                        Contacts
                                    </Paragraph>
                                </Flex>
                                {state.clientInView?.type === 'company' && (
                                    <Flex
                                        sx={{
                                            flex: 1,
                                            textAlign: 'center',
                                            alignSelf: 'center',
                                            cursor: 'pointer',
                                            height: 60,
                                            borderBottom:
                                                dataToShow === 'companies_house' ? '6px solid #e8b923' : 'unset',
                                        }}
                                        onClick={() => {
                                            toggleData('companies_house');
                                            navigate({
                                                pathname: window.location.pathname,
                                                search: `?id=${state.clientInView.id}&tab=companies_house`,
                                            });
                                        }}
                                    >
                                        <Paragraph
                                            sx={{
                                                textAlign: 'center',
                                                width: '100%',
                                                fontSize: '15px',
                                                alignSelf: 'center',
                                                fontWeight: dataToShow === 'companies_house' ? '400' : '300',
                                            }}
                                        >
                                            Companies House
                                        </Paragraph>
                                    </Flex>
                                )}
                                <Flex
                                    sx={{
                                        flex: 1,
                                        textAlign: 'center',
                                        alignSelf: 'center',
                                        cursor: 'pointer',
                                        height: 60,
                                        borderBottom: dataToShow === 'questionnaires' ? '6px solid #e8b923' : 'unset',
                                    }}
                                    onClick={() => {
                                        toggleData('questionnaires');
                                        navigate({
                                            pathname: window.location.pathname,
                                            search: `?id=${state.clientInView.id}&tab=questionnaires`,
                                        });
                                    }}
                                >
                                    <Paragraph
                                        sx={{
                                            textAlign: 'center',
                                            width: '100%',
                                            fontSize: '15px',
                                            alignSelf: 'center',
                                            fontWeight: dataToShow === 'questionnaires' ? '400' : '300',
                                        }}
                                    >
                                        Questionnaires
                                    </Paragraph>
                                </Flex>
                                <Flex
                                    sx={{
                                        flex: 1,
                                        textAlign: 'center',
                                        alignSelf: 'center',
                                        height: 60,
                                        cursor: 'pointer',
                                        borderBottom: dataToShow === 'hmrc' ? '6px solid #e8b923' : 'unset',
                                    }}
                                    onClick={() => {
                                        toggleData('hmrc');
                                        navigate({
                                            pathname: window.location.pathname,
                                            search: `?id=${state.clientInView.id}&tab=hmrc`,
                                        });
                                    }}
                                >
                                    <Paragraph
                                        sx={{
                                            textAlign: 'center',
                                            width: '100%',
                                            fontSize: '15px',
                                            alignSelf: 'center',
                                            fontWeight: dataToShow === 'hmrc' ? '400' : '300',
                                        }}
                                    >
                                        HMRC
                                    </Paragraph>
                                </Flex>
                                <Flex
                                    sx={{
                                        flex: 1,
                                        textAlign: 'center',
                                        alignSelf: 'center',
                                        cursor: 'pointer',
                                        height: 60,
                                        borderBottom: dataToShow === 'doc_sign' ? '6px solid #e8b923' : 'unset',
                                    }}
                                    onClick={() => {
                                        toggleData('doc_sign');
                                        navigate({
                                            pathname: window.location.pathname,
                                            search: `?id=${state.clientInView.id}&tab=doc_sign`,
                                        });
                                    }}
                                >
                                    <Paragraph
                                        sx={{
                                            textAlign: 'center',
                                            width: '100%',
                                            fontSize: '15px',
                                            alignSelf: 'center',
                                            fontWeight: dataToShow === 'doc_sign' ? '400' : '300',
                                        }}
                                    >
                                        Doc Sign
                                    </Paragraph>
                                </Flex>

                                <Flex
                                    sx={{
                                        flex: 1,
                                        textAlign: 'center',
                                        alignSelf: 'center',
                                        cursor: 'pointer',
                                        justifyContent: 'center',
                                        height: 60,
                                        borderBottom: dataToShow === 'documents' ? '6px solid #e8b923' : 'unset',
                                    }}
                                    onClick={() => {
                                        toggleData('documents');
                                        navigate({
                                            pathname: window.location.pathname,
                                            search: `?id=${state.clientInView.id}&tab=documents`,
                                        });
                                    }}
                                >
                                    <Paragraph
                                        sx={{
                                            textAlign: 'center',
                                            fontSize: '15px',
                                            alignSelf: 'center',
                                            fontWeight: dataToShow === 'documents' ? '400' : '300',
                                        }}
                                    >
                                        Documents
                                    </Paragraph>
                                </Flex>
                            </Flex>
                            <Flex>
                                <Flex
                                    sx={{
                                        mb: '0',
                                        pb: '0',
                                        height: '60px',
                                        borderRadius: '10px',
                                        borderBottom: '1px solid lightgray',
                                        borderBottomLeftRadius: 0,
                                        borderBottomRightRadius: 0,
                                        width: '170px',
                                        background: 'transparent',
                                        mt: '5px',
                                        ml: '5px',
                                    }}
                                >
                                    <Flex
                                        sx={{
                                            flex: 1,
                                            textAlign: 'center',
                                            alignSelf: 'center',
                                            height: 60,
                                            cursor: 'pointer',
                                            borderBottom: dataToShow === 'invoices' ? '6px solid #e8b923' : 'unset',
                                        }}
                                        onClick={() => {
                                            toggleData('invoices');
                                            navigate({
                                                pathname: window.location.pathname,
                                                search: `?id=${state.clientInView.id}&tab=invoices`,
                                            });
                                        }}
                                    >
                                        <Paragraph
                                            sx={{
                                                textAlign: 'center',
                                                width: '100%',
                                                fontSize: '15px',
                                                alignSelf: 'center',
                                                fontWeight: dataToShow === 'invoices' ? '400' : '300',
                                            }}
                                        >
                                            Invoices
                                        </Paragraph>
                                    </Flex>
                                </Flex>
                                <Flex
                                    sx={{
                                        mb: '0',
                                        pb: '0',
                                        height: '60px',
                                        borderRadius: '10px',
                                        borderBottom: '1px solid lightgray',
                                        borderBottomLeftRadius: 0,
                                        borderBottomRightRadius: 0,
                                        width: '170px',
                                        background: 'transparent',
                                        mt: '5px',
                                        ml: '5px',
                                    }}
                                >
                                    <Flex
                                        sx={{
                                            flex: 1,
                                            textAlign: 'center',
                                            alignSelf: 'center',
                                            height: 60,
                                            cursor: 'pointer',
                                            borderBottom: dataToShow === 'proposals' ? '6px solid #e8b923' : 'unset',
                                        }}
                                        onClick={() => {
                                            toggleData('proposals');
                                            navigate({
                                                pathname: window.location.pathname,
                                                search: `?id=${state.clientInView.id}&tab=proposals`,
                                            });
                                        }}
                                    >
                                        <Paragraph
                                            sx={{
                                                textAlign: 'center',
                                                width: '100%',
                                                fontSize: '15px',
                                                alignSelf: 'center',
                                                fontWeight: dataToShow === 'proposals' ? '400' : '300',
                                            }}
                                        >
                                            Proposals
                                        </Paragraph>
                                    </Flex>
                                </Flex>
                                <Flex
                                    sx={{
                                        mb: '0',
                                        pb: '0',
                                        height: '60px',
                                        borderRadius: '10px',
                                        borderBottom: '1px solid lightgray',
                                        borderBottomLeftRadius: 0,
                                        borderBottomRightRadius: 0,
                                        width: '170px',
                                        background: 'transparent',
                                        mt: '5px',
                                        ml: '5px',
                                    }}
                                >
                                    <Flex
                                        sx={{
                                            flex: 1,
                                            textAlign: 'center',
                                            alignSelf: 'center',
                                            height: 60,
                                            cursor: 'pointer',
                                            borderBottom: dataToShow === 'expenses' ? '6px solid #e8b923' : 'unset',
                                        }}
                                        onClick={() => {
                                            toggleData('expenses');
                                            navigate({
                                                pathname: window.location.pathname,
                                                search: `?id=${state.clientInView.id}&tab=expenses`,
                                            });
                                        }}
                                    >
                                        <Paragraph
                                            sx={{
                                                textAlign: 'center',
                                                width: '100%',
                                                fontSize: '15px',
                                                alignSelf: 'center',
                                                fontWeight: dataToShow === 'expenses' ? '400' : '300',
                                            }}
                                        >
                                            Expenses
                                        </Paragraph>
                                    </Flex>
                                </Flex>
                                <Flex
                                    sx={{
                                        mb: '0',
                                        pb: '0',
                                        height: '60px',
                                        borderRadius: '10px',
                                        borderBottom: '1px solid lightgray',
                                        borderBottomLeftRadius: 0,
                                        borderBottomRightRadius: 0,
                                        width: '170px',
                                        background: 'transparent',
                                        mt: '5px',
                                        ml: '5px',
                                    }}
                                >
                                    <Flex
                                        sx={{
                                            flex: 1,
                                            textAlign: 'center',
                                            alignSelf: 'center',
                                            height: 60,
                                            cursor: 'pointer',
                                            borderBottom: dataToShow === 'post' ? '6px solid #e8b923' : 'unset',
                                        }}
                                        onClick={() => {
                                            toggleData('post');
                                            navigate({
                                                pathname: window.location.pathname,
                                                search: `?id=${state.clientInView.id}&tab=post`,
                                            });
                                        }}
                                    >
                                        <Paragraph
                                            sx={{
                                                textAlign: 'center',
                                                width: '100%',
                                                fontSize: '15px',
                                                alignSelf: 'center',
                                                fontWeight: dataToShow === 'post' ? '400' : '300',
                                            }}
                                        >
                                            Post
                                        </Paragraph>
                                    </Flex>
                                </Flex>
                                <Flex
                                    sx={{
                                        mb: '0',
                                        pb: '0',
                                        height: '60px',
                                        borderRadius: '10px',
                                        borderBottom: '1px solid lightgray',
                                        borderBottomLeftRadius: 0,
                                        borderBottomRightRadius: 0,
                                        width: '170px',
                                        background: 'transparent',
                                        mt: '5px',
                                        ml: '5px',
                                    }}
                                >
                                    <Flex
                                        sx={{
                                            flex: 1,
                                            textAlign: 'center',
                                            alignSelf: 'center',
                                            height: 60,
                                            cursor: 'pointer',
                                            borderBottom: dataToShow === 'emails' ? '6px solid #e8b923' : 'unset',
                                        }}
                                        onClick={() => {
                                            toggleData('emails');
                                            navigate({
                                                pathname: window.location.pathname,
                                                search: `?id=${state.clientInView.id}&tab=emails`,
                                            });
                                        }}
                                    >
                                        <Paragraph
                                            sx={{
                                                textAlign: 'center',
                                                width: '100%',
                                                fontSize: '15px',
                                                alignSelf: 'center',
                                                fontWeight: dataToShow === 'emails' ? '400' : '300',
                                            }}
                                        >
                                            Emails
                                        </Paragraph>
                                    </Flex>
                                </Flex>
                                <Flex
                                    sx={{
                                        mb: '0',
                                        pb: '0',
                                        height: '60px',
                                        borderRadius: '10px',
                                        borderBottom: '1px solid lightgray',
                                        borderBottomLeftRadius: 0,
                                        borderBottomRightRadius: 0,
                                        width: '170px',
                                        background: 'transparent',
                                        mt: '5px',
                                        ml: '5px',
                                    }}
                                >
                                    <Flex
                                        sx={{
                                            flex: 1,
                                            textAlign: 'center',
                                            alignSelf: 'center',
                                            height: 60,
                                            cursor: 'pointer',
                                            borderBottom: dataToShow === 'other' ? '6px solid #e8b923' : 'unset',
                                        }}
                                        onClick={() => {
                                            toggleData('other');
                                            navigate({
                                                pathname: window.location.pathname,
                                                search: `?id=${state.clientInView.id}&tab=other`,
                                            });
                                        }}
                                    >
                                        <Paragraph
                                            sx={{
                                                textAlign: 'center',
                                                width: '100%',
                                                fontSize: '15px',
                                                alignSelf: 'center',
                                                fontWeight: dataToShow === 'other' ? '400' : '300',
                                            }}
                                        >
                                            Other
                                        </Paragraph>
                                    </Flex>
                                </Flex>
                            </Flex>
                            <Box
                                sx={{
                                    mb: '50px',
                                    pb: '60px',
                                    borderTop: '0px solid lightgray',
                                    borderBottom: '0px solid lightgray',
                                }}
                            >
                                <Flex
                                    sx={{
                                        width: '1300px',
                                        justifyContent: 'space-between',
                                        flexDirection: 'column',
                                        minHeight: '70px',
                                        borderRadius: '0',

                                        borderBottomLeftRadius: 0,
                                        borderBottomRightRadius: 0,
                                        ml: '5px',
                                    }}
                                >
                                    {state.loading && <Spinner />}

                                    {dataToShow === 'invoices' && <Invoices state={state} updateState={updateState} />}

                                    {dataToShow === 'proposals' && (
                                        <Proposals state={state} updateState={updateState} />
                                    )}

                                    {dataToShow === 'expenses' && <Expenses state={state} updateState={updateState} />}

                                    {dataToShow === 'post' && (
                                        <Post
                                            client={state.clientInView}
                                            organisation={organisation}
                                            state={state}
                                            updateState={updateState}
                                        />
                                    )}

                                    {dataToShow === 'key_contacts' && (
                                        <KeyContacts state={state} updateState={updateState} />
                                    )}

                                    {dataToShow === 'emails' && <Emails state={state} updateState={updateState} />}

                                    {dataToShow === 'questionnaires' && (
                                        <KeyContacts fullClientTabMode state={state} updateState={updateState} />
                                    )}

                                    {dataToShow === 'task_config' && (
                                        <ClientRelations state={state} updateState={updateState} />
                                    )}

                                    {dataToShow === 'documents' && (
                                        <Flex sx={{ flexDirection: 'column' }}>
                                            {/* <MyFileBrowser
                                                data={
                                                    state.clientInView?.client_data?.file_browser_data?.documents || []
                                                }
                                                clientId={state.clientInView?.id}
                                                updateClientData={(clientData) => {
                                                    updateState({
                                                        ...state,
                                                        clientInView: {
                                                            ...state.clientInView,
                                                            client_data: {
                                                                ...clientData,
                                                            },
                                                        },
                                                    });
                                                }}
                                            /> */}
                                            <FileExplorer
                                                data={
                                                    state.clientInView?.client_data?.file_browser_data?.documents || []
                                                }
                                                clientId={state.clientInView?.id}
                                                updateClientData={(clientData) => {
                                                    updateState({
                                                        ...state,
                                                        clientInView: {
                                                            ...state.clientInView,
                                                            client_data: {
                                                                ...clientData,
                                                            },
                                                        },
                                                    });
                                                }}
                                            />
                                        </Flex>
                                    )}

                                    {dataToShow === 'other' && (
                                        <Flex sx={{ justifyContent: 'flex-start', mt: 0, maxWidth: 1000 }}>
                                            <Flex sx={{ flexDirection: 'column', ml: 30 }}>
                                                <Paragraph sx={{ mt: 30, fontWeight: 600 }}>Comments</Paragraph>

                                                {(state.comments || []).map((x, idx) => (
                                                    <Comment
                                                        key={`comment_${idx}`}
                                                        updateState={updateState}
                                                        state={state}
                                                        refreshCallback={loadClientComments}
                                                        data={x}
                                                        page="client"
                                                        borderRadius="0px"
                                                    />
                                                ))}

                                                {state.showSubmitCommentForm && (
                                                    <AddAComment
                                                        page="client"
                                                        state={state}
                                                        updateState={updateState}
                                                    />
                                                )}

                                                <>
                                                    {state.totalComments > state.commentsLimit && (
                                                        <PgPaginationV2
                                                            currentState={state}
                                                            updateState={updateState}
                                                            totalPages={
                                                                state.totalComments
                                                                    ? Math.ceil(
                                                                          state.totalComments / state.commentsLimit
                                                                      )
                                                                    : 1
                                                            }
                                                            totalRecords={state.totalComments}
                                                            offsetKey="taskCommentsOffset"
                                                            totalKey="totalComments"
                                                            limitKey="commentsLimit"
                                                        />
                                                    )}
                                                    <Button
                                                        sx={{
                                                            mt: state.totalComments > state.commentsLimit ? -20 : 30,
                                                            mb: 30,
                                                            width: 200,
                                                            height: 40,
                                                            fontSize: 14,
                                                        }}
                                                        onClick={() =>
                                                            updateState({ ...state, showSubmitCommentForm: true })
                                                        }
                                                    >
                                                        <i
                                                            style={{
                                                                marginRight: '7px',
                                                            }}
                                                            className={`fas fa-plus-circle`}
                                                        />
                                                        Add a comment
                                                    </Button>
                                                </>
                                            </Flex>
                                            <Flex sx={{ ml: 100 }}>
                                                <Flex sx={{ flexDirection: 'column' }}>
                                                    <Paragraph sx={{ fontWeight: 600, mb: 20, mt: 30 }}>
                                                        Tools
                                                    </Paragraph>
                                                    <Button
                                                        onClick={async () => {
                                                            updateState({ ...state, showEngagementLetterModal: true });
                                                        }}
                                                        sx={{
                                                            mt: 10,
                                                            cursor: 'pointer',
                                                            backgroundColor: 'primary',
                                                            color: 'white',
                                                            width: 270,
                                                            height: 40,
                                                            fontSize: 14,
                                                        }}
                                                    >
                                                        <i
                                                            style={{
                                                                marginRight: '7px',
                                                            }}
                                                            className={`fas fa-plus-circle`}
                                                        />
                                                        Generate engagement letter
                                                    </Button>
                                                    <Button
                                                        variant="light"
                                                        onClick={() =>
                                                            updateState({
                                                                ...state,
                                                                showDeleteClientConfirmation: true,
                                                                confirmCallback: deleteClient(state, updateState),
                                                            })
                                                        }
                                                        sx={{
                                                            mt: 20,
                                                            width: 270,
                                                            cursor: 'pointer',
                                                            backgroundColor: 'white',
                                                            color: 'text',
                                                            height: 40,
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        <i
                                                            style={{
                                                                marginRight: '7px',
                                                            }}
                                                            className={`fas fa-trash`}
                                                        />
                                                        Delete client
                                                    </Button>
                                                </Flex>
                                            </Flex>
                                        </Flex>
                                    )}

                                    {dataToShow === 'companies_house' &&
                                        companyHouseItems?.length > 0 &&
                                        state?.showClientData && (
                                            <Flex sx={{ flexDirection: 'column' }}>
                                                <Heading
                                                    sx={{
                                                        fontWeight: '600',
                                                        fontSize: '20px',
                                                        color: 'text',
                                                        textAlign: 'left',
                                                        mt: '25px',
                                                        ml: 20,
                                                    }}
                                                >
                                                    Companies House Data
                                                </Heading>
                                                <Divider width="1300px" />
                                                <Flex sx={{ alignItems: 'center', ml: 20, mt: 20, mb: 20 }}>
                                                    <Paragraph sx={{ width: 270, fontSize: 14 }}>Edit</Paragraph>
                                                    <Switch
                                                        defaultChecked={state.allowCompaniesHouseEdit}
                                                        onClick={(e) =>
                                                            updateState({
                                                                ...state,
                                                                allowCompaniesHouseEdit: state.allowCompaniesHouseEdit
                                                                    ? false
                                                                    : true,
                                                            })
                                                        }
                                                    />
                                                </Flex>
                                                <Paragraph sx={{ ml: 20, width: 470, mb: 30, fontSize: 13 }}>
                                                    UK Companies with Company Numbers will have the data automatically
                                                    downloaded and anything entered manually will be overwritten
                                                </Paragraph>
                                                {companyHouseItems}
                                            </Flex>
                                        )}

                                    {dataToShow === 'doc_sign' && <DocSign state={state} updateState={updateState} />}

                                    {dataToShow === 'client_data' && (
                                        <EditClientData state={state} updateState={updateState} />
                                    )}

                                    {dataToShow === 'hmrc' && state?.showClientData && (
                                        <HMRCWrapper
                                            state={state}
                                            updateState={updateState}
                                            rawData={state?.HMRCRawData}
                                            hmrcNextSteps={state.hmrcNextSteps}
                                        />
                                    )}

                                    {dataToShow === 'companies_house' &&
                                        companyHouseItems?.length < 1 &&
                                        state?.showClientData && (
                                            <Paragraph
                                                sx={{
                                                    mt: '25px',
                                                    fontSize: '14px',
                                                    width: '100%',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                No data to show
                                            </Paragraph>
                                        )}
                                </Flex>
                            </Box>
                        </Flex>
                    </Flex>
                )}
            </Flex>
            <Flex sx={{ mb: '20px' }} />
        </Flex>
    );
};
